export const chinese_hk = {
    global: {
        test: "測試",
        next: "下一步",
        name: "姓名",
        email: "電郵",
        view: "檢視",
        edit: "編輯",
        close: "關閉",
        Close: "關閉",
        DOWNLOAD: "下載",
        submit: "提交",
        ADD: "新增",
        CANCEL: "取消",
        SAVE: "儲存",
        DELETE: "刪除",
        Delete: "刪除",
        Duplicate: "複製",
        SHARE: "分享",
        no: "否",
        type: "類型",
        english: "英文",
        thai: "泰文",
        emailEtc: "name@example.com",
        ark_for_help: "尋求協助",
        Search: "搜尋",
        workspace: "工作區",
        language: "語言",
        logout: "登出",
        search_results: "搜尋結果",
        Confirm: "確認",
        Cancel: "取消",
        account_switcher: {
            add_account: "新增帳戶",
            log_out: "登出",
            log_out_of: "登出",
            switch_failed: "切換帳戶失敗",
            sign_in_plus_email: "使用 + 電郵登入",
            your_accounts: "你的帳戶",
            email_address: "電郵地址",
            sending: "傳送中...",
            continue: "繼續",
            code_sent_to: "驗證碼已傳送至",
            verification_code: "驗證碼",
            four_digit_code: "4 位數驗證碼",
            verifying: "驗證中...",
            different_email: "其他電郵",
        },
        Save: "儲存",
    },
    category: {
        power_skill: {
            empathy: "同理心",
            self_awareness: "自我認知",
            leadership: "領導力",
            initiative_making: "主動創新",
            optimism: "樂觀態度",
            critical_thinking: "批判思考",
        },
        frequency: {
            one_time: "單次",
            weekly: "每週",
            monthly: "每月",
            quarterly: "每季",
            biannually: "每半年",
            yearly: "每年",
        },
        day_of_week: {
            monday: "星期一",
            tuesday: "星期二",
            wednesday: "星期三",
            thursday: "星期四",
            friday: "星期五",
            saturday: "星期六",
            sunday: "星期日",
        },
        day_of_week_m: {
            mon: "一",
            tue: "二",
            wed: "三",
            thu: "四",
            fri: "五",
            sat: "六",
            sun: "日",
        },
        Talent_Types: {
            Starter: "起步者",
            Marginalized: "被邊緣化",
            Latent_Potential: "潛在潛力",
            Up_and_coming: "嶄露頭角",
            Supported: "受支持者",
            Underutilized: "未充分發揮",
            Contributor: "貢獻者",
            Rising_Star: "新星",
            High_Contributor: "高貢獻者",
            Activated: "已啟動",
            Crowd_Favorite: "眾人最愛",
            Developing: "發展中",
            Community_Pillar: "社群支柱",
            Key_Player: "關鍵角色",
            Respected_Expert: "受尊敬專家",
            Distinguished_Talent: "卓越人才",
            Engaged_Contributor: "投入貢獻者",
            Valued_Contributor: "重要貢獻者",
            Untapped_Potential: "未發掘潛力",
            Emerging_Talent: "新興人才",
            Core_Player: "核心成員",
            High_Performer: "高績效者",
            Hidden_Talent: "隱藏人才",
            Unsung_Talent: "默默貢獻者",
            High_Potential: "高潛力人才",
            Solid_Performer: "穩健表現者",
            Superstar: "超級明星",
        },
        Network_type: {
            Low_Network: "低度網絡",
            Medium_Inner: "中度內部",
            High_Inner: "高度內部",
            Super_Inner: "超高內部",
            Medium_Outer: "中度外部",
            High_Outer: "高度外部",
            Super_Outer: "超高外部",
            Medium_Network: "中度網絡",
            High_Network: "高度網絡",
            Super_Network: "超高網絡",
        },
    },
    page: {
        awards: "獎項",
        awardsDescription: "透過行為導向指標獲認可為頂尖僱主",
        status: "狀態",
        timeLine: "時間軸",
        billing: "帳單",
        billing_description: "按帳單週期查看訂閱費用、獎賞活動及信用額增值",
        happilyVillage: "Happily Village",
        happilyVillage_description: "檢視及管理 Village 的互動與體驗",
        overview: "概覽",
        university: "University",
        townHall: "Town Hall",
        runningTrack: "Running Track",
        battleStadium: "Battle Stadium",
        insights: "洞察",
        insights_description: "即時了解團隊與成員的資料與洞察",
        skills: "技能",
        skills_description: "找出學習與發展的強項與機會",
        programs: "課程計劃",
        programs_description: "為入職、領導力培訓、福祉與合規等議題而設的多週引導式體驗",
        dashboard: "儀表板",
        teams: "團隊",
        cohorts: "群組",
        managers: "經理",
        people: "成員",
        reportCard: "成績卡",
        integrations: "整合",
        integrations_description: "同步員工資料並連接其他服務",
        HRIS_Sync: "HRIS 同步",
        API: "API",
        members: "成員",
        members_description: "管理成員、團隊與經理",
        power_up: "Power-ups",
        power_up_description: "向出色的成員表達認可",
        recognition: "表揚",
        recognition_description: "向出色的成員表達認可",
        performance: "績效",
        performance_description: "追蹤文化與目標的績效，了解重點領域",
        focus_areas: "重點領域",
        goals: "目標",
        coming_soon: "即將推出...",
        create: "建立",
        outbox: "寄件匣",
        activity: "動態",
        questions: "問題",
        questions_description: "管理問題、新增自訂問題並檢視回應",
        standard: "標準題庫",
        custom: "自訂問題",
        reports: "報告",
        reports_description: "預覽並下載自動產生的報告",
        daily: "每日",
        weekly: "每週",
        monthly: "每月",
        rewards: "獎賞",
        rewards_description: "管理禮品卡與公司獎賞",
        gift_cards: "禮品卡",
        perks: "福利",
        team_building: "團隊建立",
        doing_good: "行善活動",
        merchandise: "商品",
        "%_merchandise_%": "商品",
        setup_wizard: "設定精靈",
        setup_wizard_description: "讓我們開始設定！距離更快樂的職場只需數分鐘。",
        sparks: "Sparks",
        sparks_description: "改變員工與經理處理問題的方式",
        micro_learning: "微學習",
        leaderboards: "排行榜",
        settings: "設定",
        settings_description: "管理你的帳戶、成員與偏好設定",
        statusPage: "狀態頁面",
        statusPage_description: "查看 Happily 服務的即時狀態",
        documentation_dev: "技術文件 (Dev)",
        login_title: "登入",
        pincode_title: "驗證碼",
        relationship_mapping: "關係地圖",
        reward_message: "獎賞訊息",
        user_registration: "用戶註冊",
        nav_groups: {
            analyze: "分析",
            manage: "管理",
            develop: "發展",
            engage: "互動",
            admin: "管理員",
        },
    },
    commponents: {
        years: "年",
        months: "個月",
        days_ago: "天前",
        joined_after: "加入時間晚於",
        joined: "已加入",
        daily_streak: "連續天數",
        achievements: "成就",
        super_feedback: "超級意見",
        MOST_RECENT: "最近期",
        power: "能量",
        badges: "Badges",
        org: "組織",
        relationships: "關係",
    },
    setupWizard: {
        stepOne: {
            title: "歡迎",
            hi: "你好",
            header: "歡迎使用 Happily！",
            contentOne: "你很棒，願意在職場中主動創造正面體驗。有了 Happily，你可以促進更好的意見回饋、表揚、學習、社群體驗等等！",
            contentTwo: "要開始使用，我們需要先設定你的團隊、選擇獎賞並發出邀請。讓我們開始吧！",
            What_are_your: "你公司的核心價值是甚麼？",
        },
        stepTwo: {
            title: "建立團隊",
            header: "建立你的團隊",
            contentOne: "Happily 以團隊為單位運作，而經理是核心。每個工作日，意見回饋、洞察及報告都會傳送給團隊經理，協助他們即時掌握團隊狀況。請協助我們設定你的團隊。",
            teamName: "團隊名稱",
            teamNameEtc: "ACME Inc",
            managersNameEt: "經理姓名",
            email: "電郵",
            memberName: "成員姓名",
        },
        stepThree: {
            title: "選擇獎賞",
            contentOne: "團隊可利用回答每日問題（及其他互動）所獲得的 Coins 及 Gems 兌換獎賞！請於下方選擇獎賞，之後亦可再新增自訂獎賞。",
            SelectOneTitle: "公司福利",
            SelectOneContentOne: "由我們精選的職場福利開始，用以獎勵最投入的員工。",
            SelectOneContentTwo: "獎賞可於管理員主控台中設定。",
            SelectTwoTitle: "禮品卡（試用期不提供）",
            SelectTwoContentOne: "讓團隊兌換本地商戶及網上商店的禮品卡。",
            SelectTwoContentTwo: "購買點數即可啟用禮品卡，不收取額外費用。",
        },
        stepFour: {
            title: "確認與邀請",
            contentOne: "快要完成！請設定你希望團隊收到 Daily Pulse 問題的時間，建議選擇團隊上班通勤的時段。",
            quickSettings: "快速設定",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "接下來會發生的事",
            contentOneWhatHappensNext: "邀請將會發送給你的團隊，所有人會在下一個工作日收到第一批 Daily Pulse 問題。",
            contentTwoWhatHappensNext: "探索管理員主控台以新增成員、檢視洞察、建立自訂問題與獎賞，或編輯帳戶設定。",
        },
    },
    fourZeroFour: {
        looks_like_somehing: "似乎出了一點問題",
        the_page_you: "你正在尋找的頁面無法使用！",
        home_page: "主頁",
    },
    awards: {
        happily_awards: "Happily Awards",
        recognition_driven: "表揚驅動",
        the_practice_of: "表揚的實踐能帶來正向強化，對激勵頂尖人才及打造高績效團隊至關重要",
        past_thirty_day_participation: "過去 30 天參與度",
        required: "必填",
        or_higher: "或以上",
        open_feedback: "開放回饋",
        continuous_feedback_drives: "持續的意見回饋帶動持續改善，亦代表工作環境具備高度心理安全感",
        past_thirty_day_open: "過去 30 天開放回饋比率",
        active_managers: "活躍經理",
        people_managers_are: "人員經理最能主動協助團隊、提升投入度並留住人才",
        past_thirty_day_activity: "過去 30 天活動",
        strong_company_culture: "強健企業文化",
        culture_is_a_byproduct: "文化來自核心價值與行為。強健的文化讓你能有效執行策略並持續創新",
        most_recent_culture: "最近的 Culture Index 分數",
        high_well_being: "高度身心健康",
        employee_wellness_and: "員工的健康與身心福祉值得關注與照顧，並直接促進組織韌性",
        most_recent_WHO_5: "最近的 WHO-5 Index 分數",
        happiest_workplace: "最快樂的職場",
        a_happy_workplace: "快樂職場由正面習慣驅動 — 表揚、開放回饋、活躍經理、強健文化與高度身心健康",
        awards_collected: "已獲得的獎項",
        collect_all_other: "收集其他所有獎項",
        share_your_award: "分享你的獎項",
        share_your_award_with: "與他人分享你的獎項。你的獎項已發布，可透過以下網址檢視。",
        coppy: "複製",
        embed_code: "嵌入程式碼",
        preview_link_in: "在新分頁預覽連結",
        to_embed_this: "若要在你的網站嵌入此獎項，只需將以下程式碼複製並貼到網站的 HTML 程式碼中。",
        all_time: "所有時間",
        consistency: "持續性",
        current_streak: "目前連續天數",
        start_date: "開始日期",
        january_one: "1 月 1 日",
        today: "今天",
        highlighted_are_periods: "標示的期間為表揚參與度達到",
        days: "天",
        required_collect_all: "必要條件：收集其他所有獎項",
    },
    billing: {
        BILLING_SUMMARY: "帳單摘要",
        SUBSCRIPTION: "訂閱",
        REWARDS_CHARGES: "獎賞費用",
        REWARD_CREDIT_BALANCE: "獎賞點數餘額",
        REWARDS_PENDING: "待處理獎賞",
        active_members: "活躍成員",
        credit_balance: "點數餘額",
        credit_remaining: "剩餘點數",
        Date: "日期",
        Category: "類別",
        Description: "說明",
        Amount: "金額",
        Status: "狀態",
        seats_charged: "已收費席位",
        export: "匯出",
        top_up_credits: "增值點數",
        bill_sent: "帳單已發送",
        all: "全部",
        copy: "複製",
        copied_to_clipboard: "已複製到剪貼簿！",
        no_data_to_copy: "沒有可複製的資料",
        failed_to_copy: "複製到剪貼簿失敗",
        unable_to_load: "無法載入帳單資料",
        try_again: "再試一次",
        account_billing: "帳戶帳單",
        billing_period: "帳單週期",
        export_summary: "匯出摘要",
        live_calculation_note: "此頁面根據已記錄的活動及目前帳單規則即時計算。最終發票由 Happily 帳單團隊準備。",
        period_overview: "週期概覽",
        how_charges_add_up: "費用計算方式",
        pending_separate: "待處理的獎賞承擔會分開顯示，並未計入計算費用。",
        recorded_charges: "計算費用",
        charge_calculation: "訂閱費加已收取獎賞費用加增值金額等於計算總額",
        subscription_label: "訂閱費",
        rewards_charged: "已收取獎賞費用",
        credit_top_ups: "信用額增值",
        recorded_total: "計算總額",
        available_reward_credit: "可用獎賞信用額",
        available_reward_credit_help: "目前可用於兌換獎賞的信用額。",
        pending_reward_commitments: "待處理獎賞承擔",
        pending_reward_commitments_help: "已申請但尚未完成或收費的獎賞價值。",
        no_charges: "沒有計算費用",
        no_charges_help: "此週期沒有訂閱、獎賞或增值費用。",
        seat_evidence: "會員使用情況",
        Country: "國家／地區",
        member_usage_country: "按國家／地區劃分的活躍會員",
        country_usage_help: "查看此帳單週期內活躍會員在各國家／地區的分佈。上方費用按帳單貨幣分組。",
        share_of_usage: "活躍會員佔比",
        last_activity: "最後活動",
        view_members: "查看成員",
        no_member_activity: "沒有成員活動",
        no_member_activity_help: "此帳單週期未記錄活躍成員。",
        charge_details: "收費詳情",
        billing_activity: "帳單活動",
        billing_activity_help: "查看此週期的計算項目，並按收費類型分組。",
        subscription_charges: "訂閱費用",
        subscription_charges_help: "根據活躍會員及任何最低席位承諾計算的會員費用。",
        reward_credit_topups: "獎賞信用額增值",
        reward_credit_topups_help: "此帳單週期內加入獎賞錢包的信用額。",
        reward_redemptions: "獎賞兌換",
        reward_redemptions_help: "會員的獎賞申請，包括已收費、待處理及已取消項目。只有已收費項目計入上方的計算總額。",
        member_subscription: "會員訂閱",
        reward_credit_topup: "獎賞信用額增值",
        reward_redemption: "獎賞兌換",
        other_billing_activity: "其他帳單活動",
        other_billing_activity_help: "不屬於標準訂閱、增值或兌換類別的其他帳單項目。",
        less_than_one_percent: "<1%",
        entry: "項目",
        entries: "項目",
        no_activity: "沒有帳單活動",
        no_activity_help: "此週期沒有帳單項目。",
        copy_list: "複製名單",
        download_csv: "下載 CSV",
        current_period: "目前週期",
        period_range_pending: "活動載入後將顯示帳單日期範圍。",
        calculating: "計算中",
        finalised: "已完成",
        in_progress: "進行中",
        waiting_for_activity: "正在等待帳單活動",
        updated_at: "更新時間",
        all_countries: "所有國家／地區",
        billable_member_activity: "成員活動",
        not_available: "沒有資料",
        pending: "待處理",
        charged: "已收費",
        paid: "已付款",
        canceled: "已取消",
        allow_popups: "請允許彈出式視窗以開啟帳單匯出。",
        load_error_help: "請重新整理資料或稍後再試。",
    },
    happilyVillage: {
        reels: {
            reel: "短片", reels: "短片", posts: "帖文", townhall_content: "Town Hall 內容",
            new_reel: "新增短片", close: "關閉編輯器", back_to_reels: "返回短片", starter: "HR 範本", upload_video: "上載影片", build_reel: "製作短片",
            templates: { company_update: "公司最新消息", welcome_team: "歡迎新同事", recognition: "嘉許或里程碑", leadership_message: "領袖訊息", event: "活動提醒或回顧", policy: "政策或限期", blank: "空白短片" },
            storyboard: "分鏡", scenes: "場景", preview: "預覽", edit: "編輯", editor_sections: "短片編輯區",
            drag_scene: "拖曳場景 {n}", move_up: "上移", move_down: "下移", duplicate_scene: "複製場景", delete_scene: "刪除場景", add_scene: "新增場景", untitled_scene: "未命名場景", one_scene_required: "短片至少需要一個場景。", scene_moved: "{title} 已移至第 {n} 個，共 {total} 個。", editing_scene: "正在編輯場景 {n}：{title}。", scene_of: "場景 {current} / {total}", scene_type: "場景類型",
            total_duration: "總長度", recommended_duration: "建議 30–60 秒", preview_reel: "預覽 · 短片", preview_hint: "這是手機應用程式中的顯示方式。", preview_title_fallback: "與團隊分享值得關注的消息", top_safe_zone: "頂部安全區", bottom_safe_zone: "底部安全區", play: "播放", pause: "暫停", mute: "靜音", live_preview: "即時預覽", scene_label: "場景", preview_scenes: "預覽場景", unmute: "開啟聲音", scene_content: "訊息", look_and_timing: "外觀及時間",
            text: "文字", photo: "相片", video: "影片", media: "媒體", no_media: "尚未選擇媒體", choose: "選擇", replace: "更換", headline: "標題", supporting_text: "補充文字", visual_style: "視覺風格", layout: "版面", styles: { brand: "品牌", midnight: "午夜", spotlight: "焦點", fresh: "清新", paper: "紙張" }, layouts: { statement: "重點句", center: "置中", lower_third: "下方", editorial: "編輯風" }, text_effect: "文字效果", text_effects: { none: "靜止", "soft-rise": "柔和升起", "side-reveal": "側滑顯示", focus: "聚焦", stagger: "分段顯示", highlight: "重點線" }, text_effect_descriptions: { none: "文字持續顯示，不加動態。", "soft-rise": "文字柔和地升到定位。", "side-reveal": "從側面自信地滑入。", focus: "輕微放大，突出訊息。", stagger: "先顯示標題，再顯示詳情。", highlight: "先畫出重點線，再顯示訊息。" }, effect: "媒體效果", effects: { natural: "自然", studio: "專業", cinematic: "電影感", sunlit: "暖陽", vibrant: "鮮明", mono: "黑白" }, effect_descriptions: { natural: "保留原有畫面", studio: "乾淨柔和，質感細緻", cinematic: "加深對比，緩慢推近", sunlit: "溫暖光線，柔和移動", vibrant: "色彩豐富，輕微上移", mono: "經典黑白質感" }, effect_hint: "每個預設均配搭色調與動態。按播放預覽效果。", duration: "長度", fit: "顯示方式", contain: "完整顯示", cover: "填滿畫面", focal_point: "焦點位置", horizontal: "水平", vertical: "垂直", focal_point_help: "選擇媒體填滿畫面時必須保留的部分。", poster_frame: "封面畫面", poster_auto: "自動", poster_choose_frame: "選擇畫面", poster_at: "畫面時間", transition: "轉場", crossfade: "淡入淡出", none: "無",
            finished_video: "完成影片", upload_finished_video: "上載已完成的短片", upload_limits: "MP4 或 MOV · 最多 500 MB、3 分鐘", choose_video: "選擇影片", video_too_large: "請選擇小於 500 MB 的影片。", video_too_long: "請選擇 3 分鐘或以下的影片。",
            global_audio: "整體音訊", clip_audio: "片段音訊", optional_track: "選用音樂或旁白", choose_audio: "選擇音訊", reel_details: "短片資料", title: "標題", caption: "說明", tags: "標籤", add_tag: "新增標籤", subtitles_accessibility: "字幕及無障礙功能", subtitle_help: "如短片包含說話內容，請加入 SRT 或 VTT 檔案。字幕會置於手機安全區上方。", choose_subtitles: "選擇字幕檔案",
            audience: "觀眾", all_employees: "所有員工", selected_groups: "已選群組", notification: "通知", push: "推送通知", push_notice: "這會發送推送通知", push_notice_help: "短片上線時，相關人員會收到通知。", publish_when: "發佈時間", now: "現在", schedule: "排程", pick_date: "選擇日期和時間", save_close: "儲存並關閉", publish_reel: "發佈短片", schedule_reel: "排程短片",
            draft: "草稿", saving: "正在儲存…", draft_saved: "草稿已儲存", save_failed: "無法儲存", retry: "重試", save_changes: "儲存變更？", close_prompt: "將短片儲存為草稿，或捨棄編輯？", discard: "捨棄", fix_before_publish: "發佈前請修正：", template_applied: "範本已套用，所有內容均可編輯。", published_success: "短片已上線。", scheduled_success: "短片已排程。", publish_failed: "無法發佈短片，請重試。", unpublished: "已取消發佈",
            filter_reels: "篩選短片", filters: { all: "全部", draft: "草稿", rendering: "處理中", scheduled: "已排程", published: "已發佈", failed: "需要處理", archived: "已封存" }, search_reels: "搜尋短片或 #標籤", no_reels: "暫時沒有短片", no_reels_help: "建立公司更新、歡迎新同事，或上載已完成的影片。", create_first: "建立第一段短片", untitled_reel: "未命名短片", no_caption: "尚未加入說明", reel_actions: "短片操作", retry_render: "重新處理", cancel_render: "取消處理", cancel_render_prompt: "停止準備這段短片？草稿及已上載的媒體將會保留。", cancel_schedule: "取消排程", unpublish: "取消發佈", unpublish_reel: "取消發佈短片", unpublish_prompt: "從 Town Hall 移除這段短片？互動記錄會保留，你亦可再次編輯或發佈。", archive: "封存", archive_reel: "封存短片", archive_prompt: "將這段短片移至封存？如果短片正在發佈，將會從 Town Hall 移除，但互動記錄會保留。", archived_help: "這段短片已封存並從使用中的列表隱藏，互動記錄仍可查看。", restore: "還原", view_engagement: "查看互動成效", refresh_metrics: "重新整理數據", metrics_failed: "無法重新整理互動數據。", scheduled_for: "排程時間", render_failed_help: "無法準備這段短片，你的草稿及媒體仍然安全。", rendering_help: "正在準備手機影片，你可以離開此頁。", select_reel: "選擇短片", select_reel_help: "選擇短片以預覽及管理發佈。", updated: "更新於", not_set: "未設定", performance: "表現", engagement_summary: "互動摘要", mobile_activity: "手機活動", views: "觀看", completions: "完成觀看", reactions: "反應", completion_rate: "完成率", finish_publish: "檢查並發佈", review_schedule: "檢查排程", duplicate_reel: "複製短片",
            delete_reel: "刪除短片", delete_prompt: "刪除這段短片及草稿媒體？此操作無法復原。", deleted: "短片已刪除。", load_failed: "無法載入短片，請重試。", action_failed: "無法更新短片，請重試。", actions: { duplicate: "短片已複製。", retry: "已重新排隊處理。", cancel_render: "已取消處理。", cancel_schedule: "排程已取消。", unpublish: "短片已取消發佈。", archive: "短片已封存。", restore: "短片已還原。" },
            errors: { title_required: "請加入短片標題。", caption_required: "請加入簡短說明，讓大家不開聲音也能明白。", title_too_long: "標題請保持在 80 字元以內。", caption_too_long: "說明請保持在 280 字元以內。", upload_required: "請上載已完成的影片。", scenes_required: "請至少加入一個場景。", too_many_scenes: "短片最多 10 個場景。", too_long: "自製短片最長 90 秒。", scene_media_required: "請為場景 {scenes} 加入相片或影片，或改為文字場景。" },
            starter_prompt: "套用其他範本將取代目前的場景。要繼續嗎？", apply_starter: "套用範本", video_unsupported: "無法讀取此影片檔案。請選擇 MP4 或 MOV 檔案。",
            motion_effects: "動態與效果", soundtrack: "配樂", your_audio: "你的音訊", music_hint: "配樂會在準備手機影片時混入。",
            tracks: { none: "無音樂", uplift: "明快", calm: "平靜", energy: "活力", warm: "溫暖", focus: "簡約" },
            track_descriptions: { none: "只保留人聲及片段聲音", uplift: "明亮而樂觀", calm: "柔和而平穩", energy: "節奏明快有力", warm: "親切而有人情味", focus: "簡約而現代" },
            show_branding: "公司品牌", show_branding_help: "在短片上顯示公司標誌及名稱。"
        },
        Session_Type: "類型",
        Live: "現場",
        Video: "影片",
        Mission_Entries: "任務項目",
        Mission: "任務",
        add_mission: "新增任務",
        Order: "次序",
        Mission_Name_and: "任務名稱及描述",
        Entries: "項目",
        Winner: "優勝者",
        Status: "狀態",
        Week: "週",
        entries: "項目",
        Live: "進行中",
        Completed: "已完成",
        Unskip_Mission: "取消略過",
        Skip_Mission: "略過任務",
        Edit: "編輯",
        Delete: "刪除",
        Upcoming: "即將開始",
        View_Details: "檢視詳情",
        Preview_on_Mobile: "在手機版面預覽",
        New_Mission: "新任務",
        Exntry_XP: "項目 XP",
        PLAY: "參加",
        VOTE: "投票",
        Name_of_Mission: "任務名稱",
        Please_input_Name: "請輸入名稱",
        Name_of_your_Mission: "任務名稱（例如：拍最佳合照）",
        Name_of_your_Mission_th: "任務名稱（泰文）",
        Description: "描述",
        A_sentence_or_two: "關於此主題的一兩句說明",
        Please_input_Description: "請輸入描述",
        Please_input_Session_Minimum: "請輸入活動環節最少人數",
        A_sentence_or_two_th: "描述任務詳情的一兩句說明（泰文）",
        Mission_Type: "任務類型",
        Please_input_Mission_Type: "請選擇任務類型",
        Entry_Bonus_XP: "項目獎勵 (XP)",
        Please_input_Entry_Bonus: "請輸入項目獎勵",
        Please_input_Order: "請輸入次序",
        Select: "選擇",
        Please_input_Status: "請選擇狀態",
        CREATE_MISSION: "建立任務",
        SAVE_MISSION: "建立任務",
        HAPPILY_HOUSES: "HAPPILY HOUSES",
        THIS_WEEK: "本週",
        This_Week: "本週",
        This_Month: "本月",
        Last_Week: "上週",
        Last_Month: "上月",
        All_time: "全部時間",
        Level: "等級",
        total_members: "成員總數",
        House_XP: "House XP",
        XP: "XP",
        person: "人",
        Distance: "距離",
        km: "公里",
        km_per_person: "公里 / 人",
        participation: "參與度",
        university: "Happily University",
        A_count_of_how_many_learning: "來自 Happily University 活動環節的學習及活動互動總數",
        Learning_and_Activity: "學習及活動互動",
        See_more: "查看更多",
        town_hall: "Town Hall",
        A_count_of_how_many_comments: "透過 Town Hall 內主題及投票所發起的留言及回覆總數",
        Knowledge_Sharing_Interactions: "知識分享互動",
        running_track: "跑步徑",
        A_count_of_distance_traveled: "於跑步徑上步行及跑步的累積距離，包括 Boosters 的效果",
        km_Distance_Traveled: "公里累積距離",
        BATTLE_STADIUM: "BATTLE STADIUM",
        A_count_of_how_many_entries: "於 Battle Stadium 每週任務中提交的項目總數",
        House_of: "House of",
        members: "成員",
        making_up: "佔",
        of_Happily_Village: "Happily Village",
        Distance_Traveled: "累積距離",
        Running_Track_Leaderboard: "跑步徑排行榜",
        Today: "今天",
        Rank: "排名",
        Name: "姓名",
        results_from: "結果來自",
        results: "結果",
        This_week: "本週",
        No_Active_Boosters: "沒有啟用中的 Boosters",
        This_month: "本月",
        Quick_ranges: "Quick ranges",
        Specific_month: "Specific month",
        Export_this_view: "Export this view",
        Export_complete: "Export complete.",
        months_short: {
          jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
          may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
          sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
        },
        Town_Hall_Topics: "Town Hall 主題、投票及群組清單",
        Create: "建立",
        New_Topic: "新主題",
        New_Poll: "新投票",
        New_Checklist: "新清單",
        Creator: "建立者",
        Type: "類型",
        View: "檢視",
        Views: "瀏覽次數",
        Engagement: "投入度",
        Date_and_Time: "日期及時間",
        Duplicate: "複製",
        comment: "留言",
        comments: "留言",
        votes: "票",
        By: "由",
        Topic_Creator: "主題建立者",
        Share_with: "分享給",
        Huddle_selection_is: "Huddle 選項目前只能在手機應用程式中使用。",
        Coming_soon_to: "即將登陸 My Happily 控制台。",
        Team_or_Name: "團隊或收件人姓名",
        Title_of_Topic: "主題標題",
        Title_of_Poll: "投票標題",
        Short_but_descriptive: "簡短而具描述性",
        A_sentence_or_two_poll: "關於此投票的一兩句說明",
        Item_label: "項目標籤",
        Comments_enabled: "已啟用留言",
        UPLOAD_MEDIA: "上載媒體",
        Save_Changes: "儲存",
        CREATE_TOPIC: "建立主題",
        by: "由",
        Summary: "摘要",
        items: "項目",
        You_are_completed: "你已完成",
        Weekly_reminders_to: "每週提醒更新進度功能已開啟",
        Group_Checklist_Creator: "群組清單建立者",
        Select_Creator: "選擇建立者",
        Title_of_Checklist: "清單標題",
        Please_input_title: "請輸入標題",
        Checklist_Item: "清單項目",
        Description_of_Checklist: "Description",
        Checklist_item_type: "Item type",
        Item_type_simple: "Simple",
        Item_type_acknowledge: "Acknowledge",
        Item_type_link: "Link",
        Item_required: "Required",
        Acknowledge_what: "What should they acknowledge?",
        Link_placeholder: "https://...",
        Due_date: "Due date (optional)",
        Remind_7_days_before: "Remind 7 days before",
        Remind_1_day_before: "Remind 1 day before",
        Tags: "Tags",
        Add_tag: "Add a tag",
        ADD_OPTION: "新增選項",
        Show_respondents_in_results: "於結果中顯示回應者",
        Weekly_Reminders_off: "每週提醒已關閉",
        Every_week_on: "每週於",
        at: "於",
        if_checklist_is: "如清單未完成，傳送提醒通知",
        CREATE_CHECKLIST: "建立清單",
        CREATE_POLL: "建立投票",
        Poll_Creator: "投票建立者",
        Poll_Title: "投票標題",
        Option: "選項",
        Option_label: "選項標籤",
        Search: "搜尋",
        learning_and_activity_interactions: "學習及活動互動",
        University_Sessions: "Happily University 活動環節",
        add_session: "新增活動環節",
        campaigns: "活動",
        Create_Campaign: "建立活動",
        Campaign_Title: "活動標題",
        Icon: "圖示",
        Theme: "主題",
        Input_Type: "輸入類型",
        Timing: "時間安排",
        Goal: "目標",
        Reward: "獎賞",
        Entry_Cost: "參加費用",
        Daily: "每日",
        Weekly: "每週",
        Instant_Coins: "即時 Coins",
        Charged_Coins_On_Completion: "完成時扣除 Coins",
        Prize_Pool_Split_At_End: "獎金池（結束時分配）",
        Individual_Goal: "個人目標",
        Group_Goal: "群組目標",
        Start_Date: "開始日期",
        End_Date: "結束日期",
        Participants: "參與者",
        All: "全部",
        Sign_ups: "報名",
        name: "名稱",
        Topic: "主題",
        Price: "價格",
        coins: "Coins",
        Free: "免費",
        Led_by: "主持人",
        SIGN_UPS: "報名",
        spots_available: "剩餘名額",
        PRICE: "價格",
        Coming_soon_to_the: "即將登陸 My Happily 控制台。",
        Name_of_Session: "活動環節名稱",
        Short_but_descriptive_eg: "簡短而具描述性（例如：Excel Analysis 101）",
        A_sentence_or_two_about: "關於此活動環節的一兩句說明",
        When: "何時",
        Please_input_Date: "請輸入日期及時間",
        Duration_minutes: "時長（分鐘）",
        How_long: "多長時間？",
        Please_input_Duration: "請輸入時長",
        Location: "地點",
        Please_input_Location: "請輸入地點",
        Session_Limit: "活動環節名額",
        Where: "在哪裡",
        How_many: "多少個？",
        Please_input_Session_Limit: "請輸入活動環節名額",
        Price_coins: "價格 (Coins)",
        Please_input_rice: "請輸入價格",
        How_much: "多少？",
        Add_to_Topic: "新增至主題",
        Comment_Permissions: "留言權限",
        CREATE_SESSION: "建立活動環節",
        Created_by: "建立者",
        sign_ups_of: "報名人數",
        available_spots: "剩餘名額",
        No_one_sign_up: "尚未有人報名。",
        campaign_form: {
            preview_notice: "正式推出前功能或有變動。",
            content_language: "內容語言",
            translation_mode_title: "下方僅顯示可翻譯的欄位。",
            translation_mode_hint: "切換至英文以編輯所有活動設定。",
            use_english_empty: "空白欄位使用英文",
            use_english: "使用英文",
            live_lock_title: "進行中的活動編輯受限。",
            live_lock_body: "你仍可更新顯示欄位，如類別、標題、描述、圖示、主題及留言權限。活動開始後，時間安排、目標、獎賞、對象、參加設定及活動內容將被鎖定。",
            translatable_content: "可翻譯內容",
            campaign_overview: "活動概覽",
            category: "類別",
            category_placeholder: "例如：產品知識、健康",
            activity_type: "活動類型",
            activity_type_placeholder: "選擇活動類型",
            title: "標題",
            title_placeholder: "輸入活動標題或問題",
            description: "描述",
            description_placeholder: "描述此活動的內容及參與者將做甚麼…",
            description_hint: "此描述會在參與者加入活動時顯示給他們看",
            translation_required: "需要翻譯",
            validation_category: "請輸入活動類別",
            validation_title: "請輸入活動標題",
            validation_icon: "請選擇圖示",
            color_theme: "顏色主題",
            activity_settings: "活動設定",
            locked_after_start: "活動開始後鎖定。",
            success_answer: "正確答案",
            yes_is_correct: "「是」為正確答案",
            no_is_correct: "「否」為正確答案",
            input_settings: "輸入設定",
            allow_decimals: "允許小數值",
            allow_decimals_hint: "適用於體重、距離或其他需要精確度的指標（例如 1.5、0.8）",
            tracking_mode: "追蹤模式",
            incremental: "逐次累加",
            incremental_hint: "每項記錄獨立計算（例如「本週減 1.5 磅」）",
            cumulative: "累計總和",
            cumulative_hint: "每項記錄為活動開始以來的總數（例如「共減 5 磅」）",
            campaign_duration: "活動期間",
            duration_locked: "活動開始後，開始及結束時間將被鎖定。",
            select_frequency: "選擇頻率",
            day_of_week: "星期幾",
            select_day: "選擇日子",
            select_start_date: "選擇開始日期",
            number_of_days: "天數",
            number_of_weeks: "週數",
            ends: "結束",
            unit_translation: "單位翻譯",
            unit_of_measurement: "量度單位",
            unit_placeholder: "例如：件、步、分鐘",
            unit_hint: "此單位將與所有目標一同顯示（例如「10 件」、「1000 步」）",
            goals: "目標",
            goals_locked: "活動開始後，目標設定將被鎖定。",
            limit: "上限",
            required: "必填",
            optional: "選填",
            target: "目標",
            max_allowed: "最大允許值",
            max_total: "最高總數",
            target_total: "目標總數",
            max_combined: "最高合計",
            target_combined: "目標合計",
            individual_overall_goal: "個人整體目標",
            individual_overall_limit: "個人整體上限",
            group_overall_goal: "群組整體目標",
            group_overall_limit: "群組整體上限",
            recommended: "建議",
            weeks: "週",
            days: "天",
            yesno_desc_daily: "參與者每日答中即為成功",
            yesno_desc_weekly: "參與者每週答中即為成功",
            reward_locked: "活動開始後，獎賞機制將被鎖定以保障派發邏輯。",
            earn_per_item: "達成每日目標後，每完成一項可獲獎賞",
            earn_on_daily_goal: "只在達成每日目標時獲獎賞",
            charged_coins: "扣除 Coins",
            prize_pool: "獎金池",
            prize_pool_description: "參加費用加扣除的 Coins 形成獎金池，由優勝者平均分配",
            access_participation: "存取及參與",
            access_locked: "活動開始後，對象及參加設定將被鎖定。",
            audience: "對象",
            select_commenter: "選擇可留言人士",
            who_can_comment: "可留言人士",
            coins_to_join: "參加所需 Coins",
            entry_limit: "參加上限",
            no_limit: "無限制",
            set_participant_limit: "設定參與者上限",
            checklist_items: "清單項目",
            add_checklist_hint: "新增參與者可剔選的項目",
            translate_checklist_hint: "翻譯每個清單項目",
            enter_checklist_item: "輸入清單項目",
            add_first_item: "新增第一個項目",
            add_another_item: "新增另一項目",
            no_checklist_to_translate: "沒有可翻譯的清單項目。請先以英文新增項目。",
            quiz_questions: "測驗問題",
            translate_quiz_hint: "翻譯每條問題及其答案選項",
            question: "問題",
            remove: "移除",
            enter_question: "輸入你的問題",
            no_quiz_to_translate: "沒有可翻譯的測驗問題。請先以英文新增問題。",
            add_question: "新增問題",
            add_first_question: "新增你的第一條問題",
            update_campaign: "儲存變更",
            create_campaign: "建立活動",
            launch: "啟動",
            launch_now: "立即啟動",
            launch_now_sub: "儲存後立即生效",
            schedule_later: "排程啟動",
            schedule_later_sub: "選擇日期與時間",
            launch_datetime: "啟動日期與時間",
            pick_datetime: "選擇日期與時間",
            scheduled_must_be_future: "排程啟動時間必須在未來",
            launch_locked: "活動開始後不能變更啟動時間",
            launch_campaign: "啟動活動",
            schedule_campaign: "排程活動",
        },
        Actions: "操作",
        Topic_actions: "主題操作",
        Session_actions: "活動環節操作",
        No_topics_or_polls: "沒有主題或投票",
        No_results_found: "找不到結果…",
        No_sessions: "沒有活動環節",
        No_session_found: "找不到活動環節…",
        Caption: "說明",
        Download_Results: "下載結果",
        Be_the_first_to_comment: "成為第一個在此討論留言的人",
        Reply: "回覆",
        Likes: "讚好",
        Reply_here: "在此回覆…",
        Comment_here: "在此留言…",
        Sessions_tab: "活動環節",
        Campaigns_tab: "活動",
        Session_Minimum: "活動環節最少人數",
        Session_Maximum: "活動環節最多人數",
        one_coin: "1 Coin",
        no_signups_yet: "尚未有人報名",
        signups_empty_hint: "用戶報名此活動後將在此顯示",
        signed_up_count: "已報名",
        signed_up_badge: "已報名",
        signed_up_label: "已報名",
        no_participants_yet: "尚未有參與者",
        participants_empty_hint: "參與者加入活動後將在此顯示",
        achieved_goal: "達成目標",
        Achieved_Goal: "達成目標",
        coins_awarded: "獲發 Coins",
        starts_tomorrow: "明天開始",
        starts_in: "開始倒數",
        days: "天",
        days_left: "剩餘天數",
        last_day: "最後一天",
        no_data_yet: "尚無資料",
        summary_empty_hint: "有參與者加入活動後，摘要將在此顯示",
        investment_and_impact: "投入與成效",
        per_active_participant: "每位活躍參與者",
        via: "透過",
        daily_goals_lower: "每日目標",
        entry_fees_collected: "已收取的參加費用",
        free_entry: "免費參加",
        coins_distributed: "已派發 Coins",
        coins_committed: "已承諾 Coins",
        in_escrow: "託管中",
        returned_to_system: "已退回系統",
        didnt_meet_goal: "未達成目標",
        daily_goals_hit: "已達每日目標",
        total_actions: "總行動次數",
        limited_data_notice: "資料有限 — 隨活動推進，預測將更準確",
        projected_total_investment: "預計總投入：",
        Active: "進行中",
        achievement_rate_lower: "達成率",
        reward_breakdown: "獎賞明細",
        coins_per_daily_goal: "每個每日目標的 Coins",
        daily_target: "每日目標",
        daily_goals_achieved: "已達成每日目標",
        total_actions_recorded: "已記錄的行動總數",
        total_coins_invested: "已投入 Coins 總數",
        total_coins_committed: "已承諾 Coins 總數",
        earned_by: "由",
        who_met_goal: "達成目標者獲得",
        returned_from: "退回自",
        who_didnt: "未達成者",
        in_escrow_until_end: "託管至活動結束",
        total_pool_size: "獎金池總額",
        current_winners: "目前優勝者",
        prize_per_winner: "每位優勝者獎金",
        no_winners_yet: "尚無優勝者",
        campaign_results: "活動結果",
        progress: "進度",
        achievement_rate: "達成率",
        avg_score: "平均分",
        participation_rate: "參與率",
        drop_off: "流失率",
        view_leaderboard: "檢視排行榜",
        Close: "關閉",
        coins_committed_to_behavior: "為行為改變承諾的 Coins",
        coins_earned_through_behavior: "透過行為改變賺得的 Coins",
        type_quiz: "測驗",
        type_count: "計數",
        type_auto_sync: "自動同步",
        type_steps: "步數",
        type_sleep: "睡眠",
        type_screen_time: "螢幕時間",
        type_exercise: "運動",
        type_distance: "距離",
        type_multiple_selection: "多項選擇",
        type_yes_no: "是/否",
        status_active: "進行中",
        status_upcoming: "即將開始",
        status_scheduled: "已排程",
        status_ended: "已結束",
        status_archived: "已封存",
        challenge_default: "挑戰",
        preview_day: "日",
        preview_streak: "連續",
        preview_select_answer: "選擇正確答案",
        preview_todays_activity: "今日活動次數",
        preview_daily_goal: "每日目標",
        preview_keep_going: "繼續加油！你做得很好！",
        preview_submit_count: "提交次數",
        preview_goal_label: "目標",
        preview_last_sync: "上次同步：2 分鐘前",
        preview_manually_edit: "手動編輯",
        preview_continue: "繼續",
        preview_morning_routine: "完成你的早晨例行",
        preview_done_for_now: "我暫時完成了",
        preview_yesno_question: "你今日達成目標了嗎？",
        preview_charging: "充能中",
        early_preview: "搶先體驗",
        early_preview_hint: "你已獲搶先體驗！此功能即將向所有人開放。",
        no_campaigns: "沒有活動",
        period: "期間",
        campaign_actions: "活動操作",
        archive: "封存",
        delete_disabled_hint: "刪除（僅限無參與者）",
    },
    insights: {
        HAPPINESS_VS_RISK_RATE: "幸福感對比風險與活動",
        Duration: "期間",
        Last_30_days: "過去 30 天",
        Last_60_days: "過去 60 天",
        Last_13_weeks: "過去 13 週",
        Last_26_weeks: "過去 26 週",
        Last_52_weeks: "過去 52 週",
        Last_24_months: "過去 24 個月",
        HAPPINESS: "幸福感",
        RISK: "風險",
        ACTIVE_USERS: "活躍用戶",
        COHORT_STATUS: "群組狀態",
        Sort_by: "排序依據",
        Cohorts: "群組",
        Satisfaction: "滿意度",
        Co_Alignment: "公司一致性",
        Score_Distribution: "分數分佈",
        Engagement_and_Impact: "投入度與影響力",
        Highlighting_key_engagement_metrics: "重點展示關鍵投入度指標，例如 eNPS、NPS、Wellness、Culture 及 Employee Resilience Index 分數，以及個人影響力和經理活動的概覽。",
        high_impact: "高影響力",
        contributors: "貢獻者",
        People: "人員",
        managers: "經理",
        non_active: "不活躍",
        active: "活躍",
        Managers: "經理",
        eNPS: "eNPS",
        Report_Card: "成績單",
        Promoters: "Promoters",
        Passives: "Passives",
        Detractors: "Detractors",
        Excellent: "優秀",
        Fair: "一般",
        Critical: "危急",
        Poor: "較差",
        point_same_benchmark: "分與基準相同",
        points: "分",
        above_benchmark: "高於基準",
        below_benchmark: "低於基準",
        Happiness_Rate: "幸福感分數",
        Risk_Rate: "風險率",
        View_by_team: "按團隊檢視",
        Open_ended_Feedback: "開放式意見回饋",
        How_would_you_like: "你希望你的",
        manager_to_be_more: "經理如何更多地參與？",
        Activity: "活動",
        Adoption: "採用率",
        Members: "成員",
        Monthly_Active_Users: "每月活躍用戶",
        Weekly_Active_Users: "每週活躍用戶",
        ACTIVITY_THIS_WEEK: "本週活動",
        WEEKLY_ACTIVE_USERS: "每週活躍用戶",
        HAPPINESS_RATE: "幸福感分數",
        RISK_RATE: "風險率",
        FEEDBACK_RESPONSE_RATE: "意見回饋回應率",
        By_Job_Tenure: "按在職年資",
        Engagement_Trend: "投入度趨勢",
        Engagement_Trend_Desc: "以 Dynamic Engagement Behavioral Index (DEBI) 量度的 3 個月內投入度變化，涵蓋整體公司、經理及領導層。",
        A_breakdown_of_your: "依在職年資（員工於公司任職時間）劃分的活動與各項比率細節",
        Real_time_Activity: "即時活動",
        PAST_12_HOURS: "過去 12 小時",
        BY_HOUR: "按小時",
        TOP_ACTIVITIES: "熱門活動",
        TIMES: "次",
        Interactions_caption: "互動次數",
        No_activity_yet: "過去 12 小時內沒有活動",
        Key_Teams_and_Cohorts: "重點團隊與群組",
        Highlighting_key_groups: "重點展示在幸福感、風險、意見回饋率或活動上有顯著高分或低分的關鍵群組",
        TONE_ANALYZER: "Tone Analyzer",
        BETA: "BETA",
        TALKING_POINTS: "討論要點",
        show_timeline: "顯示時間軸",
        Success_Score: "成功分數",
        Dimension: "維度",
        Status_no_teams: "團隊健康度",
        teams_below_healthy: "個團隊低於健康水平",
        no_team_data: "尚無團隊數據",
        Critical_teams: "嚴重團隊",
        No_critical_teams: "此維度沒有嚴重團隊",
        Loading_teams: "正在載入團隊…",
        responses: "則回應",
        Positive: "正面",
        Neutral: "中立",
        Close: "關閉",
        ENGAGEMENT_BREAKDOWN_BY_TEAM: "按維度劃分的投入度",
        Most_teams_red: "最多團隊處於危急",
        Biggest_drop: "跌幅最大",
        Lowest_Success_Score: "最低成功分數",
        Highest_Success_Score: "最高成功分數",
        DIMENSION_DETAILS: "維度詳情",
        Lowest_Happiness: "最低幸福感",
        Highest_Happiness: "最高幸福感",
        Lowest_Risk: "最低風險",
        Highest_Risk: "最高風險",
        ACTIVITY_OVERVIEW: "活動概覽",
        ACTIVE: "積極回應",
        PASSIVE: "中等",
        INACTIVE: "偏低",
        DAILY_INSIGHTS_OPENED: "每日洞察開啟",
        WEEKLY_INSIGHTS_OPENED: "每週洞察開啟",
        FEEDBACK_REPLY_RATE: "意見回饋回覆率",
        BY_MANAGER: "經理互動",
        Managers_activity_in: "經理過去 30 天開啟洞察及回覆團隊意見回饋的活動",
        Insights_Open_Rate: "洞察開啟率",
        Team_Size: "團隊人數",
        Feedback_Reply_Rate: "意見回饋回覆率",
        All_Activity_Types: "所有活動類型",
        Active: "積極回應",
        Passive: "中等",
        Inactive: "偏低",
        Insights_Opened: "已開啟洞察",
        Feedback: "意見回饋",
        Relational: "關係",
        Team_Challenges: "團隊挑戰",
        Date: "日期",
        Score: "分數",
        Challenge: "挑戰",
        Status: "狀態",
        Profile: "個人檔案",
        Daily: "每日",
        Weekly: "每週",
        Reply: "回覆",
        Super: "Super",
        Talent_Type: "人才類型",
        Excels_At: "擅長領域",
        Network_Type: "網絡類型",
        Critical_Areas: "關鍵領域",
        critical_area: "關鍵領域",
        results_from: "結果來自",
        results: "結果",
        Lower: "下限",
        Upper: "上限",
        SAVE: "儲存",
        CANCEL: "取消",
        Select_all: "全選",
        Clear: "清除",
        Talent_Types_are_tagged: "人才類型會按網絡效能（個人對組織的協作貢獻）及個人評分（經理對表現的評估）分為 Low、Rising、High 或 Super 等不同級別",
        Cancel: "取消",
        Okay: "確定",
        Power_Skills: "Power Skills",
        OUTER_NETWORK: "外部網絡",
        NETWORK_EFFECTIVENESS: "網絡效能",
        PEOPLE_INTELLIGENCE: "People Intelligence",
        INDIVIDUAL_PERFORMANCE: "個人表現",
        INNER_NETWORK: "內部網絡",
        Sort_By: "排序依據",
        Highest_Risk_Level: "最高風險等級",
        Lowest_Risk_Level: "最低風險等級",
        Highest_Star_Count: "最多星數",
        Lowest_Star_Count: "最少星數",
        Highest_Impact_Rating: "最高影響力評分",
        Lowest_Impact_Rating: "最低影響力評分",
        Super_Network_Effectiveness: "⬆️ Super Network Effectiveness ",
        Rising_Network_Effectiveness: "⏫ Rising Network Effectiveness",
        High_Network_Effectiveness: "🔼 High Network Effectiveness",
        Low_Network_Effectiveness: "🔽 Low Network Effectiveness",
        Super_Individual_Rating: "⬆️ Super Individual Rating",
        Rising_Individual_Rating: "⏫ Rising Individual Rating",
        High_Individual_Rating: "🔼 High Individual Rating",
        Low_Individual_Rating: "🔽 Low Individual Rating",
        No_Description: "沒有描述",
        Problem_Areas: "問題領域",
        People_Impact_and: "人員影響力與風險趨勢",
        RISK_LEVELS: "風險等級",
        AVG_IMPACT_RATING: "平均影響力評分",
        view_list: "查看列表",
        Excels_at: "擅長",
        profiles: "個人檔案",
        were_tagged_by: "被同事標記為具備此項特質",
        Name_Team_and: "姓名、團隊與幸福感",
        Talent_is_classified: "人才按照獲得表揚的頻率與質量分類",
        coins_and_gems: "（Coins 和 Gems）。Coins 衡量的是",
        Network: "網絡",
        Effectiveness: "效能",
        Gems_are_a_measure: "Gems 衡量的是",
        Individual_Performance: "個人表現",
        Low: "低",
        Low_frequency: "低頻率",
        Uptake: "上升中",
        A_recent_increase_in: "頻率近期有所提升",
        High: "高",
        High_frequency: "高頻率",
        High_frequency_and_high: "高頻率及高質量",
        Read_more_here: "在此了解更多",
        Impact_Rating: "影響力評分",
        Based_on_manager_and: "根據過去 6 個月內經理及同事的表揚。",
        Based_on_connections_created: "根據過去 6 個月內透過同事意見回饋、表揚及送禮互動所建立的連結。",
        Engagement_Group: "投入度群組",
        Based_on_the_quality_and: "根據上個月關鍵投入行為的質量與付出。",
        Truly_Outstanding: "Truly Outstanding",
        Truly_Outstanding_ratings: "過去 6 個月內從同事意見回饋中獲得的 Truly Outstanding 評級。",
        Medals: "獎牌",
        Medals_received_in_the: "過去 6 個月內獲得的獎牌。",
        Star_Performer: "Star Performer",
        Number_of_weeks_qualified: "過去 6 個月內符合 Star Performer 資格的週數。",
        Talent_is_classified_by: "人才按內部及外部連結數量分類",
        connections_as_determined: "連結（根據組織架構判定）來自",
        recognition_and_peer: "表揚及同事意見回饋資料",
        Low_Network: "低網絡",
        Low_inner_and_outer: "內部及外部連結皆低",
        High_Inner: "高內部",
        High_Inner_but_low: "內部連結高但外部連結低",
        High_Outer: "高外部",
        Low_inner_but_high: "內部連結低但外部連結高",
        High_Network: "內部及外部連結皆高",
        Achievements: "成就",
        Risk_Level: "風險等級",
        Talent_that_are_retention: "人才中存在留任風險者，透過頻率偵測",
        of_Not_Great_and: "「Not Great」及「Unhappy」回應對「How are",
        you_feeling_today: "you feeling today?」問題",
        Twice_last_week: "上週兩次",
        Medium: "中等",
        More_than_twice: "上週超過兩次",
        More_than_twice_last_and: "上週及前一週皆超過兩次",
        Highlighting_key_accomplishments: "重點展示在投入度及來自同事與經理表揚方面的關鍵成就",
        Highly_Moderately_Somewhat_Under: "Highly、Engaged、Somewhat、Under Engaged 或 In-active 投入度群組會根據行為指標分配。",
        Recognized_with_a_Leadership: "獲頒 Leadership Medal of Excellence 表揚。",
        Recognized_as_Truly_Outstanding: "在同事意見回饋互動中獲認可為 Truly Outstanding。",
        A_star_is_earned: "當符合 Star Performer 資格、於任一週內進入表揚接收者前 15% 時，即獲得一顆星。",
        A_score_that_represents: "代表個人對組織及周圍同事影響力的分數，由以下因素決定",
        TEAMS: "團隊",
        COHORTS: "群組",
        REPORT_CARD_BY_TEAM: "按團隊劃分的成績單",
        REPORT_CARD_BY_COHORTS: "按群組劃分的成績單",
        Highest_Scores: "最高分數",
        Lowest_Score: "最低分數",
        Scores_are_updated_on: "分數會按季更新，並可與先前分數作比較檢視",
        SCORE_HISTORY: "分數歷史",
        Max_Change: "最大變化",
        Most_Recent: "最近",
        NPS: "NPS",
        NPS_Details: "NPS 詳情",
        WHO_5: "WHO-5",
        eRes: "eRes",
        Culture: "文化",
        DEBI: "DEBI",
        Index: "指數",
        Alignment: "一致性",
        Variance: "團結度",
        Net_Promoter_Score_c_NPS: "Net Promoter Score ® (NPS)",
        Engagement_Score: "投入度分數",
        Engagement_Score_is: "Dynamic Engagement Behavioral Index (DEBI) 是一種量度員工投入度的整體方法，超越自我報告資料，採用更以行為為依據的評估。",
        Strategic_Alignment: "Strategic Alignment",
        Strategic_Alignment_is: "Strategic Alignment Index 量度團隊於四個關鍵維度上理解並執行優先事項的程度：Understanding & Clarity、Execution & Confidence、Resource & Support 及 Impact & Contribution。分數越高（0-100）代表日常工作與組織目標的一致性越強。Consistency Score 反映團隊成員之間此理解的一致程度，分數越高代表策略一致性越穩定。",
        DEBI_report_card_label: "Dynamic Engagement Behavior Index 量度真實投入度",
        Culture_Resilience_Well: "文化、韌性、身心健康指數",
        Net_Promotor_Score_is: "Net Promoter Score 是以 promoters、passives 及 detractors 計算，範圍介乎 -100 與 +100 之間。",
        Net_Promoter_Net_Promoter: "Net Promoter、Net Promoter System、Net Promoter Score、NPS 及 NPS 相關的表情符號為 Bain & Company, Inc.、Fred Reichheld 及 Satmetrix Systems, Inc. 的註冊商標。",
        A_collection_of_indexes: "一系列指數，協助你更深入了解組織文化、韌性及身心健康。",
        The_Culture_Index_is: "Culture Index 是根據可反映組織文化強度的行為量度而制定。",
        The_Employee_Resilience_Index: "Employee Resilience Index 提供從挫折中復原及應對挑戰能力的指標。",
        The_WHO_5_Index_from: "WHO-5 Index 來自世界衞生組織，是身心健康的通用量度標準。",
        Loyal_employees_who_are: "忠誠並以與你共事為傲的員工，是你吸引優秀人才及在危機中克服挑戰的最大資產。",
        Company_alignment_provides: "公司一致性讓經理與領導者了解員工對公司目標的貢獻程度。任何不一致都是資源的未充分利用，會阻礙相關員工的成長、發展與投入度。",
        Feedback_has_significant: "意見回饋對員工的個人及團隊表現具有重大效益。員工需要清楚了解如何改進，持續溝通至為關鍵",
        Recent_studies: "近期研究",
        focus_on_how_mindset: "聚焦於心態如何在釋放員工投入度方面發揮關鍵作用。",
        Social_educational_and: "社會、教育及組織心理學揭示心態如何作為個人資源，透過對發展的熱情、對付出的詮釋、注意力聚焦、對挫折的認知及人際互動，影響員工的投入度。",
        Managers_play_an_importan: "經理在管理及塑造團隊心態方面扮演重要角色。",
        Employees_need_to_feel_that_they_are: "員工需要時刻感到自己在個人及專業上都在成長與學習。經理可透過擔任教練及引導團隊學習機會來發揮作用，亦必須讓職業發展機會變得清晰透明。",
        Employees_need_to_feel_taht_their_work: "員工需要感到他們的工作被他人看見，付出得到應有的肯定。表揚已被引用為 5 大可預測員工投入度的主要活動之一。",
        The_support_that_employees: "員工從同事得到的支援，與他們管理壓力（wellness）的能力有密切關聯。",
        Studies: "研究",
        show_that_satisfaction_with: "顯示對同事的滿意度與投入度有顯著關聯。",
        The: "一個人",
        more_embedded_a_person: "越深入融入工作",
        is_in_their_job: "，離職的可能性就越低。若同事與團隊成員之間出現衝突或問題，經理與領導者必須能立即採取行動。",
        Managers_set_standards_for: "經理為團隊設下標準，而直屬下屬都希望令他們留下好印象！為建立有效關係，經理應每 2 週至少與每位直屬下屬進行一次有意義的互動。與經理有定期會議的員工，感到投入並在工作中蓬勃發展的可能性高達三倍。",
        Apart_from_pay_challenging: "除薪酬外，具挑戰性的工作已被確認為員工的關鍵激勵因素。員工需要感到自己正過著充實的職業生涯，並從事難度適中的工作，正如 Mihaly Csikszentmihalyi 在《Flow - The Psychology of Optimal Experience》一書中所闡述的心流理論。",
        Employees_need_work_life: "員工需要工作與生活的平衡，以保持生產力及對工作的投入。研究顯示職場壓力與過勞對員工投入度具中介效應，身體與心理健康皆須兼顧。",
        Before: "之前",
        After: "之後",
        Compare: "比較",
        There_is_no_happiness: "暫無幸福感、風險或活動資料可顯示。請明日再回來查看！",
        SPOTLIGHT: "焦點",
        Most_Engaged: "最投入",
        Teams_with_highest_engagement: "投入度分數最高的團隊。該分數代表 9 個投入度維度的綜合分數。",
        No_most_engaged_at: "目前暫無最投入團隊",
        Retention_Risks: "留任風險",
        Teams_with_highest_retention: "留任風險分數最高的團隊。該分數代表與流失相關維度的綜合分數。",
        No_retention_risks_at: "目前暫無留任風險",
        Teams_that_show_the_most: "過去 2 週進步最大的團隊。該分數代表投入度分數的上升幅度。",
        No_most_improved_at: "目前暫無最進步團隊",
        Most_Critical: "最危急",
        Teams_that_are_most_critical: "過去 2 週處於最危急狀態的團隊。該分數代表投入度分數的下降幅度。",
        Most_Improved: "最進步",
        No_most_critical: "目前暫無最危急團隊",
        TEAM_STATUS: "團隊狀態",
        Team: "團隊",
        Happi_Rate: "幸福感分數",
        Wellness: "Wellness",
        Rel_Manager: "與經理關係",
        Recognition: "表揚",
        Ambassadorship: "代言程度",
        Rel_Colleagues: "與同事關係",
        Personal_Growth: "個人成長",
        Strategic_Alignment_Details: "Strategic Alignment 詳情",
        Strategic_Alignment_Breakdown: "Strategic Alignment 細節",
        Strongly_Agree: "非常同意",
        Agree: "同意",
        Disagree: "不同意",
        Strongly_Disagree: "非常不同意",
        WHO_5_Breakdown: "WHO-5 細節",
        WHO_5_Details: "WHO-5 詳情",
        Culture_Index_Details: "Culture Index 詳情",
        Culture_Index_Breakdown: "Culture Index 細節",
        Scoped: "指定範圍",
        Global: "全部",
        Current_Filtered_List: "目前篩選列表",
        Entire_Company: "整間公司",
        people_impact: "人員影響力",
        workplace_culture_impact: "職場文化影響力",
        people_impact_tooltip_desc: "根據行為分析及個人對職場文化的貢獻",
        high_impact_label: "高影響力",
        high_impact_desc: "積極推動正向文化，表揚他人，持續保持投入",
        moderate_impact_label: "中等影響力",
        moderate_impact_desc: "穩定的貢獻者，定期參與，支援他人",
        low_impact_label: "低影響力",
        low_impact_desc: "投入有限，或需額外支援",
        people_impact_target: "目標：高影響力與中等影響力合計 ≥70% 以達至最佳表現",
        manager_activity: "經理活動",
        manager_feedback_responsiveness: "經理意見回饋回應度",
        manager_activity_tooltip_desc: "根據對團隊意見回饋的回覆率",
        manager_responsive_label: "積極回應",
        manager_responsive_desc: "持續回覆團隊意見回饋以維持團隊投入",
        manager_moderate_label: "中等",
        manager_moderate_desc: "定期回覆但可能遺漏部分意見回饋",
        manager_minimal_label: "偏低",
        manager_minimal_desc: "回覆不頻繁，或需在意見回饋上接受指導",
        manager_activity_target: "目標：經理回覆率 ≥80% 以達至最佳表現",
        focus_and_goal_alignment: "Focus & Goal Alignment",
        focus_alignment_tooltip: "追蹤團隊焦點領域與公司目標的一致程度。",
        focus_coverage_tooltip_bullet: "• Focus Coverage：即時快照",
        goal_alignment_tooltip_bullet: "• Goal Alignment：過去 90 天",
        learning_section_title: "學習",
        learning_tooltip: "追蹤團隊學習及技能發展進度。",
        learning_progress_tooltip_bullet: "• Learning Progress：過去 6 個月",
        focus_coverage: "Focus Coverage",
        focus_areas: "Focus Areas",
        last_week: "上週",
        people_with_focus_connector: "／共",
        people_with_focus_suffix: "人已設定焦點",
        goal_alignment: "Goal Alignment",
        goals_label: "目標",
        aligned_suffix: "一致",
        unaligned_suffix: "不一致",
        unknown_label: "未知",
        unknown_suffix: "項目的一致性未知",
        setup_goals_empty_state: "設定目標以追蹤一致性",
        alignment_not_available: "焦點資料不足，未能評估一致性",
        learning_progress: "Learning Progress",
        learning_journeys: "Learning Journeys",
        members_upskilling: "成員正在提升技能",
        completed_label: "已完成",
        tenure_empty_state: "你的年資洞察將在你加入 Happily 首日後顯示，協助我們展示具意義的團隊模式。",
        overall_label: "整體",
        leadership_label: "領導層",
        pending_data: "資料待處理",
        communication_health: "溝通健康度",
        show_all_teams_prefix: "顯示全部",
        show_all_teams_suffix: "個團隊",
        show_less: "顯示較少",
        Select: "選擇",
        All_Cohorts: "所有群組",
        All_Teams: "所有團隊",
        Search_cohorts_placeholder: "搜尋群組...",
        No_data_for_time_period: "目前時段沒有資料可顯示。",
        Happiness_Rate_tooltip: "每日 pulse 問題「How do you feel today?」中回答「Very Happy」或「Pretty Good」的比率",
        Risk_Rate_tooltip: "每日 pulse 問題「How do you feel today?」中回答「Not Great」或「Terrible」的比率",
        Avg_Impact: "平均影響力",
        Avg_Impact_tooltip: "群組成員的平均影響力評分，計算方式為個人影響力分數總和除以成員人數",
        DEBI_Score: "DEBI Score",
        DEBI_Score_tooltip: "每個群組的 Dynamic Engagement Behavioral Index (DEBI) 由多項因素決定：群組成員簽到及回應頻率、意見回饋質量、對同事的表揚活動，以及與組織核心價值觀的一致性。",
        ENGAGEMENT_SCORE: "投入度分數",
        DEBI_by_role: "按角色劃分的 Dynamic Engagement Behavioral Index",
        Manager: "經理",
        Leader: "領導者",
        Six_mo_Retention: "6 個月留任",
        Six_mo_Retention_tooltip: "6 個月留任率，計算為仍在職群組成員的百分比。公式：目前群組人數 ÷（目前群組人數 + 過去 6 個月封存員工數）× 100",
        ARCHIVED_MEMBERS_HISTORY: "已封存成員歷史",
        Number_of_archived_by_month: "每月封存成員人數",
        Terminated: "解僱",
        Resigned: "辭職",
        Preparing_cohort_data: "正在準備群組資料，請稍候...",
        Organizational_Network: "組織網絡",
        Organizational_Network_desc: "呈現過去 6 個月內透過同事／經理表揚、意見回饋交流及有意義互動所形成的連結",
        Focusing: "聚焦中",
        Nodes: "Nodes",
        Attribute: "屬性",
        Links: "連結",
        Relationships: "關係",
        Relationship_Attributes: "關係屬性",
        Relationship_Power: "關係力量",
        Filter_by_power_rating: "按力量評分分類群組篩選",
        Signature: "Signature",
        Filter_by_signature: "按關係中標記的 signature 值篩選",
        Connections: "連結",
        Engagement: "投入度",
        Signatures: "Signatures",
        Name_Team: "姓名、團隊",
        No_signatures_available: "沒有可用的 signature",
        All_Signatures: "所有 Signatures",
        more_suffix: "更多",
        Focus_in_relationship_map: "在關係地圖中聚焦",
        Total: "總計",
        Manager_Responsiveness: "經理回應度",
        Manager_Activity_Details: "經理活動詳情",
        Managers_play_central_role: "經理在連結目標與行動及成果方面扮演核心角色。",
        Performance_Metrics: "表現指標",
        Feedback_Rate: "意見回饋率",
        Reply_Rate: "回覆率",
        Performance_Boosts_On_Track: "Performance Boosts 按計劃進行",
        Insights_and_Nudges: "洞察與提示",
        Daily_Insights: "每日洞察",
        Weekly_Insights: "每週洞察",
        Coaching_Suggestions: "指導建議",
        Coaching_Suggestions_desc: "AI 生成的行動項目於過去 4 週的每週報告中發送給經理。這些個人化建議協助經理提升團隊投入度及表現。",
        Individual_Manager_Analysis: "個別經理分析",
        Manager_Scorecard: "經理計分卡",
        Manager_Scorecard_desc: "此計分卡提供經理主要活動及表現指標的概覽，聚焦於他們與直屬下屬的互動，協助了解經理在示範關鍵行為、推動表現及帶動團隊投入方面的成效。",
        Manager_Scorecard_definition: "Manager effectiveness, 0–100. A weighted score of the leadership behaviors and team outcomes your company values most.",
        Scorecard_Settings: "Scorecard settings",
        Performance_reviews_enabled: "Performance reviews enabled",
        Category_Weights: "Category weights",
        Advanced_weights: "Advanced: weight individual metrics",
        Show_composite_as: "Show composite as",
        Save_settings: "Save settings",
        Reset: "Reset",
        Performance_Group: "表現群組",
        All_Performance_Groups: "所有表現群組",
        Elite_Managers: "精英經理",
        High_Performers: "高表現者",
        Rising_Stars: "新星",
        Feedback_Champions: "意見回饋冠軍",
        At_Risk_Managers: "風險經理",
        Ghost_Managers: "沉寂經理",
        Conv_Initiated: "發起對話",
        Conv_Initiated_tooltip: "此經理主動與其上級經理發起的對話比例，展現主動向上溝通",
        Peer_Feedback: "同事意見回饋",
        Peer_Feedback_tooltip: "此經理為自身提出的同事意見回饋請求次數，展示其自我提升的承諾",
        Boosts_On_Track: "Boosts 按計劃",
        Boosts_On_Track_tooltip: "已完成或待處理但未逾期的 performance boosts 比例",
        Goals_Progress: "目標進度",
        Goals_Progress_tooltip: "直屬下屬在表現檢討中所評估的整體進度",
        Culture_Contr: "文化貢獻",
        Culture_Contr_tooltip: "直屬下屬對文化的貢獻程度，於表現檢討中評估",
        Reply_Rate_tooltip: "過去 30 天經理已回應的團隊意見回饋比例",
        Reply_Rate_short: "回覆率",
        Reply_Rate_line1: "回覆",
        Reply_Rate_line2: "率",
        Insights_Opened_tooltip: "從電子郵件收件匣開啟 Manager Insights 的比例。註：若電郵追蹤被封鎖，數據可能不準確",
        Insights_Opened_short: "已開啟洞察",
        Team_DEBI: "團隊 DEBI",
        Team_DEBI_line1: "團隊",
        Team_DEBI_line2: "DEBI",
        DEBI_Score_col_tooltip: "此經理團隊的 Dynamic Engagement Behavior Index，以其直屬下屬為基礎。這是 DEBI 行為指標，因此可能與 People Intelligence 的投入度綜合分數不同。",
        Action_Items_line1: "行動",
        Action_Items_line2: "項目",
        Manager_Coaching_Interactions: "經理指導互動",
        Manager_Classification_Settings: "經理分類設定",
        View_detailed_breakdown: "查看詳細分析",
        Proactivity_Rating_Breakdown: "Proactivity 評分細節",
        Psychological_Safety_Breakdown: "Psychological Safety 細節",
        People_Risk_Recovery_Trends: "人員風險與復原趨勢",
        Click_any_week_for_details: "點擊任何一週以查看詳情",
        Recovery: "復原",
        AVG: "平均",
        Percentile: "百分位數",
        Name_and_Team: "姓名及團隊",
        Health_Indicator: "健康指標",
        Contributions: "貢獻",
        Talent_and_Network: "人才與網絡",
        Organizational_Positioning: "組織定位",
        Medals_and_Peer_Ratings: "獎牌與同事評分",
        Skills_and_Values: "技能與價值觀",
        Overall_Score: "整體分數",
        col_name_team_tooltip: "員工姓名、部門，以及根據近期意見回饋的當前身心健康狀態",
        col_contributions_tooltip: "來自同事的表揚及經理的表現評估",
        col_talent_network_tooltip: "員工的人才分類及組織網絡範圍",
        col_achievements_tooltip: "透過獎牌及高同事意見回饋評分獲得的表揚",
        col_alignment_tooltip: "評估員工關鍵技能的熟練程度及與公司價值觀的一致性",
        col_impact_rating_tooltip: "整體表現分數附每週變化指標",
        Support: "支援",
        Performance: "表現",
        Performance_subtitle: "KR 或寶石率",
        Performance_subtitle_kr: "KR · {progress}%",
        Performance_subtitle_gem: "寶石率",
        Performance_dataNote_kr: "此人所擁有目標的 KR 進度與 KR 健康度的平均值。",
        Performance_dataNote_gem: "寶石率（文化和目標均評為 3+），以互動次數加權。基於過去 6 個月。",
        Happiness: "快樂指數",
        Happiness_subtitle: "每日簽到",
        Happiness_dataNote: "來自每日簽到的快樂回應模式，反映近期情緒。與使用 WHO-5 指數的「幸福感（Wellbeing）」不同。",
        Wellbeing: "幸福感",
        Wellbeing_subtitle: "季度訊號",
        Wellbeing_dataNote: "來自每日簽到的近期幸福感訊號。WHO-5（核心幸福基準）有資料時於展開面板顯示。",
        Impact_Rating_dataNote: "整體貢獻綜合分數。結合投入行為與組織影響。每週更新。70 分以上代表強投入度。",
        Flight_Risk: "離職風險",
        Flight_Risk_subtitle: "90 天信號",
        Flight_Risk_Low: "低",
        Flight_Risk_Moderate: "中等",
        Flight_Risk_High: "高",
        Flight_Risk_Safe: "安全",
        Flight_Risk_Watch: "留意",
        Flight_Risk_At_risk: "有風險",
        Engagement_subtitle: "過去 30 天",
        Performance_subtitle_v2: "目標與回饋",
        Peer_Trust_subtitle_v2: "信任 · 網絡",
        Band_Excellent: "卓越",
        Band_Good: "良好",
        Band_Fair: "尚可",
        Band_Watch: "留意",
        Band_Poor: "偏低",
        No_data: "暫無數據",
        Performance_no_reviews: "暫無評估",
        Recognized_By: "獲認可來自",
        Recognized_as_outstanding_by: "獲卓越認可來自",
        Recognized_as_outstanding: "獲卓越認可",
        Peer_single: "位同儕",
        Past_6_mo: "過去 6 個月",
        Past_6_months: "過去 6 個月",
        Medals: "獎牌",
        Giving: "給予",
        Receiving: "獲得",
        Vs_team_median_6mo: "對比團隊中位數 (6 個月)",
        Band_top_quartile: "頂尖 25%",
        Band_above_median: "高於平均",
        Band_typical: "一般",
        Band_below_typical: "低於平均",
        Truly_Outstanding: "卓越非凡",
        Exceeding_Expectations: "超出預期",
        Skill_band_developing: "起步階段",
        Skill_band_building: "建立基礎",
        Skill_band_applying: "積極應用",
        Skill_band_integrated: "純熟整合",
        Skill_band_mastery: "精通領導",
        Values_band_strong: "高度契合",
        Values_band_aligned: "契合",
        Values_band_mixed: "混合",
        Values_band_emerging: "初步形成",
        Values_split_given_label: "給予",
        Values_split_received_label: "獲得",
        Values_tooltip_intro: "由 AI 分析同儕認可活動。",
        Values_tooltip_events_suffix: "個認可事件（過去 60 天）",
        Not_measured: "尚未測量",
        More: "更多",
        Flight_Risk_dataNote: "根據過去 90 天紅色（不快樂）每日簽到模式建立。數值越高 = 投入度下降風險越大。",
        Peer_Trust: "同儕信任",
        Peer_Trust_subtitle_short: "信任分數 · 同儕",
        Peer_Trust_dataNote: "結合同儕回饋活動、認可的互惠性、網絡關係深度及收到的認可品質。基於過去 6 個月。",
        Peers: "同儕",
        Coins: "金幣",
        Gems: "寶石",
        Engagement: "投入度",
        Checkin_consistency: "簽到一致性",
        Giving_recognition: "給予認可",
        Receiving_recognition: "獲得認可",
        Manager_responsiveness: "經理回應度",
        No_manager_assigned: "尚未指派經理",
        Risk_reason: "風險原因",
        Goals: "目標",
        Power_Skills: "核心技能",
        Empathy: "同理心",
        Self_Awareness: "自我覺察",
        Critical_Thinking: "批判性思維",
        Leadership: "領導力",
        Initiative: "主動性",
        Optimism: "樂觀",
        Positioning_and_Achievements: "定位與成就",
        Engagement_and_Contributions: "投入與貢獻",
        Context_and_Power_Skills: "情境與核心技能",
        Show_details_for: "顯示 {name} 的詳細資訊",
        col_happiness_tooltip: "來自每日簽到的快樂回應模式。WHO-5 為核心幸福（Wellbeing）基準，若有資料則顯示。",
        col_wellbeing_tooltip: "來自每日簽到的近期幸福感訊號。WHO-5（核心幸福基準）有資料時於展開面板顯示。",
        col_engagement_tooltip: "個人分數根據過去 30 天的簽到、回饋、認可與同儕活動計算。\n其他 DEBI 視圖可能包含團隊關係與網絡動態。",
        col_flight_risk_tooltip: "根據過去 90 天簽到模式判斷的投入度下降可能性。",
        col_performance_tooltip: "擁有目標時為 KR 進度，否則為同儕評定的寶石率。",
        col_peer_trust_tooltip: "同儕信任程度與同儕關係廣度。",
        Engagement_dataNote: "結合 6 個每月指標：每日簽到（30%）、開放式回饋（20%）、認可活動（20%）、經理回饋（10%）、認可品質（10%）和同儕回饋（10%）。基於最近一個月。",
        Skills: "技能",
        Values: "價值觀",
        Values_Alignment: "價值觀一致性",
        Talent_Group: "人才群組",
        All_People: "所有人員",
        risk_drilldown: {
            title: "風險深入分析",
            high: "高",
            med: "中",
            low: "低",
            recovered: "已復原",
            recovered_lc: "復原",
            no_change: "沒有變化",
            selected: "已選擇",
            col_name: "姓名",
            col_frequency: "頻率",
            col_history: "歷史",
            exited: "已離職",
            weeks_short: "／ 8 週",
            at_risk: "有風險",
            week_of: "所屬週",
            recurring: "重複出現",
            first_time: "首次",
        },
        spotlight: {
            highlighting_teams: "重點展示值得關注的團隊，所屬週為",
            most_engaged: "最投入",
            most_engaged_desc: "投入度分數最高的團隊。該分數代表 9 個投入度維度的綜合分數。",
            retention_risks: "留任風險",
            retention_risks_desc: "留任風險分數最高的團隊。該分數代表與流失相關維度的綜合分數。",
            most_improved: "最進步",
            most_improved_desc: "過去 2 週進步最大的團隊。該分數代表投入度分數的上升幅度。",
            most_critical: "最危急",
            most_critical_desc: "過去 2 週處於最危急狀態的團隊。該分數代表投入度分數的下降幅度。",
            team: "團隊",
            score: "分數",
        },
    },
    goals: {
        team_goals: "團隊目標",
        goals_description: "管理並追蹤每個團隊的目標",
        add_goals: "新增目標",
        edit_goals: "編輯目標",
        save: "儲存",
        cancel: "取消",
        team_name: "團隊",
        goals_label: "團隊目標",
        goals_placeholder: "輸入團隊目標與願景，每行一項...",
        goals_hint: "這些目標將用於為經理及其團隊提供針對性的分析與回饋建議。",
        add_goals_title: "新增團隊目標",
        edit_goals_title: "編輯團隊目標",
        no_teams: "找不到團隊",
        no_goals: "尚未設定目標",
        save_success: "目標已成功儲存",
        save_error: "儲存目標時發生錯誤，請再試一次。",
        kr_templates: {
            revenue_mrr_title: "提升每月經常性收入",
            revenue_mrr_reasoning: "以營收為主的目標建議追蹤金額成長作為可衡量的成果。",
            revenue_deals_title: "本季完成新客戶簽約",
            revenue_deals_reasoning: "成交數量是營收成長的領先指標。",
            revenue_deal_size_title: "提升平均成交金額",
            revenue_deal_size_reasoning: "較大的成交金額可在不成比例增加投入下放大營收成長。",
            customer_nps_title: "達到目標 NPS 分數",
            customer_nps_reasoning: "NPS 直接反映客戶滿意度與忠誠度。",
            customer_churn_title: "降低客戶流失率",
            customer_churn_reasoning: "流失率降低代表客戶體驗與留存能力提升。",
            customer_support_title: "提升支援工單處理速度",
            customer_support_reasoning: "更快的處理速度直接影響客戶滿意度。",
            hire_fill_title: "補滿開放職缺",
            hire_fill_reasoning: "按招聘計劃追蹤人力補足進度。",
            hire_time_title: "縮短招聘所需時間",
            hire_time_reasoning: "更快招聘能提升團隊節奏並降低機會成本。",
            hire_retention_title: "新員工 90 天留任率",
            hire_retention_reasoning: "早期高留任代表入職流程有效且角色匹配。",
            ship_features_title: "如期推出計劃中的功能",
            ship_features_reasoning: "功能交付數量可追蹤產品藍圖的執行情況。",
            ship_bugs_title: "降低漏至正式環境的錯誤率",
            ship_bugs_reasoning: "漏出率下降代表發布前品質提升。",
            ship_adoption_title: "達到新功能的使用者採用率",
            ship_adoption_reasoning: "採用率能驗證已發布功能確實滿足使用者需求。",
            engage_score_title: "提升團隊投入度分數",
            engage_score_reasoning: "投入度分數反映整體團隊的健康與動力。",
            engage_participation_title: "提升意見回饋參與度",
            engage_participation_reasoning: "較高的參與率代表心理安全感與投入度。",
            engage_turnover_title: "降低自願離職率",
            engage_turnover_reasoning: "離職率下降代表文化與員工滿意度提升。",
            generic_milestones_title: "完成關鍵里程碑",
            generic_milestones_reasoning: "里程碑追蹤為此目標提供清晰的進度檢查點。",
            generic_completion_title: "達到目標完成率",
            generic_completion_reasoning: "整體完成百分比可單一呈現目標進度。",
            generic_improvement_title: "達成可衡量的改善",
            generic_improvement_reasoning: "量化改善能讓進展清晰可見並具有激勵作用。",
            unit_deals: " 宗",
            unit_hires: " 人",
            unit_days: " 天",
            unit_features: " 項功能",
            unit_milestones: " 個里程碑",
            unit_percent_within_sla: "% 在 SLA 內",
            unit_percent_of_users: "% 的使用者",
        },
    },
    integrations: {
        API_DOCUMENTATION: "API 文件",
        Reference_and_instructional: "可用 API 操作的參考及教學指南",
        Go_to_API_Doc: "前往 API 文件",
        PRODUCTION_TOKEN: "生產環境權杖",
        This_is_your_production: "這是你的生產環境權杖。API 權杖必須與其他密碼一樣妥善保管。",
        Generate_a_Token: "產生權杖",
        API_LOG: "API 記錄",
        A_log_of_API_activity: "由與你的帳戶相關聯的 API 權杖建立的 API 活動記錄，列出 API 交易的日期、API 操作、狀態及部署類型。",
        results_from: "結果來自",
        results: "結果",
        SELECT_SYNC_METHOD: "選擇同步方式",
        INTEGRATION_PARAMETERS: "整合參數",
        Webhook: "Webhook",
        Sort_by_Name: "按名稱排序",
        Token: "權杖",
        Webhook_Endpoint: "Webhook 端點",
        Sync_Type: "同步類型",
        Staged_Syncing: "分階段同步",
        Your_members_are_queued_up: "你的成員會被排入佇列，準備新增或停用。此方式讓你在執行前可手動檢視變更。",
        Normal_Syncing: "一般同步",
        Users_can_be_added: "使用者可以直接加入 Happily，並會根據你提交資料中的狀態自動新增或停用",
        Syncing: "同步中",
        All_users_who_are: "所有在 Happily 中但不在提交資料內的使用者將會被停用",
        Options: "選項",
        Abbreviate_Team_Name: "縮寫團隊名稱",
        Automatically_abbreviate_long_team: "自動縮短過長的團隊名稱，讓報告和洞察更易閱讀",
        Enable: "啟用",
        Enable_web_hook: "啟用 Webhook",
        Any_data_that: "你提交至 Webhook 的任何資料都會與你的網絡同步",
        Save_Changes: "儲存變更",
        WEBHOOK_LOGS: "WEBHOOK 記錄",
        Sync_users_using_your: "使用你的 HRIS 同步使用者。此列表包含最近 50 次 HRIS Webhook 請求。你可以",
        Simulate_Changes: "模擬變更",
        to_see_how_the: "以查看使用目前 HRIS Webhook 同步設定時，資料會如何影響你的網絡",
        Date: "日期",
        Webhook_Content: "Webhook 內容",
        Integration_Status: "整合狀態",
        Actions: "操作",
        View_Changes: "檢視變更",
        No_webhook_activity: "未記錄 Webhook 活動",
        Members: "成員",
        INTEGRATION_STATUS: "整合狀態",
        HRIS_Sync: "HRIS 同步",
        Sync_your_employee_data: "將員工資料與 HRIS 同步，統一管理成員流程",
        Connected: "已連接",
        Setup: "設定",
        Developer_API: "開發者 API",
        Activate_your_developer: "啟動開發者計劃並取得憑證以使用 API 服務",
        SSO_Title: "單一登入 (SSO)",
        SSO_Desc: "啟用 SSO 作為成員帳戶的驗證及配置方式",
        Directory_Sync: "目錄同步",
        Endpoint: "端點",
        Enable_Directory_Sync: "啟用目錄同步",
        Directory_Sync_Desc: "由你的目錄所提交的任何資料都會與 Happily 帳戶同步",
        slack: {
            loadingConfig: "正在載入 Slack 設定……",
            connectTitle: "將 Happily 連接至 Slack",
            connectDescription: "將表揚、洞察及投入度直接帶入你的團隊 Slack 工作區。",
            feature: {
                recognitionTitle: "表揚廣播",
                recognitionDesc: "自動在 Slack 頻道中分享表揚",
                reportsTitle: "經理報告摘要",
                reportsDesc: "每日及每週洞察透過私訊送達",
                nudgesTitle: "簽到提示",
                nudgesDesc: "溫和提醒鼓勵參與",
                reactionTitle: "反應同步",
                reactionDesc: "Slack 反應同步回 Happily",
            },
            connecting: "連接中……",
            connectButton: "連接至 Slack",
            redirectNote: "你將會被導向 Slack 以授權 Happily",
            comingSoon: "Slack 整合後端正在設定中，請稍後再查看！",
            connectedTo: "已連接至",
            connectedOn: "已連接",
            byUser: "由",
            test: "測試",
            disconnect: "中斷連接",
            featuresSection: "功能",
            toggle: {
                recognitionDesc: "將表揚發佈至 Slack 頻道",
                dailyReportTitle: "每日報告摘要",
                dailyReportDesc: "給經理的早晨洞察",
                weeklyReportTitle: "每週報告摘要",
                weeklyReportDesc: "逢星期一的每週摘要",
                nudgesDesc: "以溫和提醒鼓勵參與",
                reactionDesc: "在 Happily 追蹤 Slack 反應",
            },
            channelSettings: "頻道設定",
            recognitionChannel: "表揚頻道",
            selectChannel: "選擇頻道",
            teamChannels: "同時發佈至團隊專屬頻道",
            dmRecipients: "直接私訊收件人",
            nudgeSettings: "提示設定",
            triggerAfter: "觸發於",
            daysWithoutCheckin: "天未簽到",
            maxPerWeek: "每週上限",
            nudgesPerPerson: "每人提示次數",
            saving: "儲存中……",
        },
        sso: {
            selectMethod: "選擇 SSO 方式",
            general: "一般",
            providerId: "SSO 提供者 ID",
            providerIdPlaceholder: "提供者 ID",
            connectionName: "連線名稱",
            connectionNamePlaceholder: "連線的邏輯識別名稱",
            entityId: "Entity ID",
            signInUrl: "登入網址",
            certificate: "憑證",
            certificatePlaceholder: "以 PEM 或 CER 格式編碼的 SAMLP 伺服器公鑰",
            syncProfileAttributes: "同步個人檔案屬性",
            syncAtLogin: "於每次登入時同步使用者個人檔案屬性",
            syncAtLoginDesc: "於每次登入時更新名字、姓氏及個人檔案相片資料",
            setupInfo: "設定資料",
            authCallbackUrl: "驗證回呼網址",
            on: "開",
            off: "關",
            ssoEnabledLabel: "SSO 已啟用為登入方式",
            dangerZone: "危險區域",
            deleteConnection: "刪除連線",
            deleteConnectionDesc: "一經確認，此操作無法復原！成員登入將會還原為 OTP。",
            removeConnection: "移除此連線",
        },
    },
    login: {
        sign_in_to: "登入",
        please_enter_your: "請輸入你的電郵地址",
        keep_me_logged: "保持登入狀態",
        terms_and_Conditions: "條款及細則",
        sign_in: "登入",
        your_account_access: "你的帳戶存取權已被封鎖，不在有效的存取範圍內",
        your_IP: "你的 IP",
    },
    members: {
        ORGANIZATION_CHART_VIEW: "組織架構圖",
        the_org_chart: "目前檢視的組織架構圖太大，無法匯出為圖片檔案。",
        Members: "成員",
        incomplete_profiles: "未完成的個人檔案",
        Archived: "已封存",
        ADD_MEMBER: "新增成員",
        EXPORT_ALL: "全部匯出",
        REVIEW_UPDATES: "檢視更新",
        members_selected: "已選成員",
        RE_ASSIGN_MANAGER: "重新指派經理",
        EDIT_TEAM: "編輯團隊",
        ADD: "新增",
        EDIT: "編輯",
        ARCHIVE: "封存",
        SEND_INVITE: "發送邀請",
        RE_ASSIGN: "重新指派",
        IGNORE: "忽略",
        Invited: "已邀請",
        Active: "啟用",
        Inactive: "停用",
        All: "全部",
        New: "新",
        Team: "團隊",
        Member: "成員",
        Assign_Team: "指派團隊",
        Assign_Manager: "指派經理",
        Coins: "Coins",
        Gems: "Gems",
        Permission: "權限",
        Status: "狀態",
        results_from: "結果來自",
        results: "結果",
        coins: "coins",
        gems: "gems",
        years: "年",
        months: "個月",
        days_ago: "天前",
        joined_after: "加入於",
        Joined: "加入日期",
        Daily_Streak: "Daily Streak",
        Achievements: "成就",
        Super_Feedback: "Super Feedback",
        Problem_Areas: "待改善範疇",
        MOST_RECENT: "最新",
        Powers: "Powers",
        Badges: "Badges",
        Knowledge: "知識",
        Initiative: "主動性",
        Contributor: "貢獻者",
        Leadership: "領導力",
        Health: "健康",
        Org: "組織",
        Relationships: "關係",
        Are_you_sure_would: "你確定要封存此成員嗎？",
        Once_archived_the_member: "一旦封存後，該成員將自動被登出 Happily，並且無法再次登入。",
        Archived_members_can_be: "已封存的成員可於日後還原。",
        CANCEL: "取消",
        First_Name: "名字",
        Last_Name: "姓氏",
        Email: "電郵",
        Manager: "經理",
        Select_a_Manager: "選擇經理",
        Select_a_Team: "選擇團隊",
        will_be_created_as_a: "將會建立為新團隊",
        User_role: "使用者角色",
        emoji_Member: "👩🏻 成員",
        Limited_Access: "有限存取權",
        emoji_Admin: "✍🏻  Admin",
        integrations: "整合",
        Manage_Account_Email_Notifications: "管理帳戶、電郵通知",
        emoji_HR: "👩🏻‍💻  HR",
        Manage_Account_Insights: "管理帳戶、洞察",
        emoji_Leader: "👩🏻‍💼 Leader",
        Insights_Medals: "洞察、獎章",
        emoji_Super_Leader: "🦸🏻‍♀️ Super Leader",
        Manage_Account_Insights_Medals: "管理帳戶、洞察、獎章",
        emoji_Super_Admin: "🙆🏻‍♀️ Super Admin",
        Manage_Account_Insights_Email: "管理帳戶、洞察、電郵通知",
        Language: "語言",
        Country: "國家",
        English: "英文",
        Thai: "泰文",
        BahasaMalay: "馬來文",
        ChineseHK: "中文（繁體，香港）",
        BrazilianPortuguese: "巴西葡萄牙文",
        Burmese: "緬甸文",
        SAVE_CHANGES: "儲存",
        Automatically_send_an: "自動向新成員發送邀請電郵",
        Archive_employee: "封存員工",
        Archived_Type: "封存類型",
        Direct_Reports: "直屬下屬",
        Re_Assign_Manager: "重新指派經理",
        Search_manager_name: "搜尋經理姓名",
        Suggestions_based_on_member: "根據選擇的成員或搜尋欄位提供建議",
        SUBMIT: "提交",
        Archived_Employee: "已封存員工",
        Edit_Team: "編輯團隊",
        Edit_Manager: "編輯經理",
        members: "成員",
        Top_Most: "最頂層",
        UNARCHIVE: "還原",
        DELETE: "刪除",
        delete_all: "刪除全部",
        Unarchive: "還原",
        Delete: "刪除",
        Search_team_name: "搜尋團隊名稱",
        Complete_manager_assignment: ">完成經理指派",
        is_missing_a_direct: "缺少直屬經理。請選擇一位經理以確保管理層級完整。",
        SELECT_DIRECT_MANAGER: "選擇直屬經理",
        Re_assign_a_manager: "重新指派經理以取代",
        the_archived_manager: "已封存的經理",
        has_been_archived_leaving: "已被封存，剩下",
        members_without_a_direct: "位成員沒有直屬經理。請重新指派經理以確保管理層級完整。",
        Teams: "團隊",
        powers: "powers",
        CREATE_TEAM: "建立團隊",
        badges: "badges",
        Information: "資料",
        Sort_by_Direct_Reports: "按直屬下屬排序",
        duplicate_teams: "重複團隊",
        Sort_by_Name: "按名稱排序",
        ADD_TEAM: "新增團隊",
        Sort_by_Parent: "按上級團隊排序",
        Team_Manager: "團隊經理",
        Parent_Team: "上級團隊",
        Team_Name: "團隊名稱",
        Auto_assignment: "自動指派",
        Color_Tag: "顏色標籤",
        A_unique_team_name: "團隊名稱必須唯一",
        A_parent_team_and: "系統會根據團隊成員與經理的關係，自動指派上級團隊及經理",
        Select_a_color_tag: "選擇顏色標籤以視覺化組織團隊，例如按業務單位或部門劃分",
        No_team_members: "沒有團隊成員",
        Managers: "經理",
        Search: "搜尋",
        managers_selected: "已選經理",
        Cohorts: "群組",
        CREATE: "建立",
        duplicate_cohorts: "重複群組",
        ADD_COHORT: "新增群組",
        Cohort_Name: "群組名稱",
        Select_Member: "以姓名、電郵或團隊新增",
        Select_Leaders: "以姓名指派領導者（選填）",
        Auto_generated: "自動產生",
        Bulk_add_by_inputing: "以逗號分隔的電郵地址批量新增",
        Add_members_to_this: "新增成員至此群組",
        No_Cohort_members: "沒有群組成員",
        Cohort_Leader: "群組領導者",
        Leader_description: "群組領導者會收到每日及每週洞察",
        Cohort_Type: "群組類型",
        Manual: "手動",
        Dynamic: "動態",
        Configure_Dynamic_Rules: "設定動態規則",
        Dynamic_cohort_description: "系統會根據你於下方設定的規則自動新增或移除成員。",
        Preview: "預覽",
        Please_add_at_least_one_valid_rule: "請為動態群組新增至少一項有效規則。",
        Error_previewing_cohort: "預覽群組時發生錯誤。請再試一次。",
        No_members_match: "沒有成員符合目前的規則",
        team_audit: {
            title: "團隊關係審核",
            teams_analyzed: "已分析團隊",
            discrepancies_found: "發現不一致",
            analyzing: "正在分析團隊關係…",
            all_valid: "所有團隊的上下級關係均有效！",
            fix: "修正",
            manual_review_tooltip: "無法自動修正 — 需要人手檢視",
            manual_review: "人手檢視",
            team_manager: "團隊經理",
            multiple_managers: "多位經理",
            unassigned: "未指派",
            managers_boss: "經理的上司",
            no_boss_top_level: "沒有上司（最頂層）",
            team_hierarchy: "團隊層級",
            current_structure: "目前結構",
            recommended: "建議",
            no_parent_team: "沒有上級團隊",
            should_have_no_parent: "不應有上級團隊",
            new_badge: "新",
            fix_all_issues: "修正所有問題",
            rerun_audit: "重新審核",
            failed_run: "審核失敗",
            fixed_relationship_for: "已修正上下級關係：",
            failed_fix: "修正失敗",
            fixed_prefix: "已修正",
            fixed_suffix: "項團隊關係",
            some_failed: "部分關係無法修正",
        },
        search_by_name_or_team: "以姓名或團隊搜尋",
        preparing_org_chart_download: "正在準備組織架構圖下載，請稍候…",
        cohorts: {
            main_conditions: "主要條件",
            nested_group: "巢狀群組",
            members_must_match: "成員必須符合",
            add_rules_or_groups_below: "於下方新增規則或群組",
            add_rule: "新增規則",
            add_group: "新增群組",
            select_attribute: "選擇屬性",
            select_operator: "選擇運算子",
            select_value: "選擇值",
            select_values: "選擇值",
            type_to_search: "輸入以搜尋",
            min: "最小",
            max: "最大",
            and: "至",
        },
        relationship_mapping: {
            outer_network: "外圍網絡",
            inner_network: "核心網絡",
        },
        profile: {
            view_personal_context: "檢視個人背景",
            download_photo: "下載相片",
            personal_context_suffix: " 的個人背景",
            personal_context_subtitle: "從溝通模式與意見回饋中分析，以更深入了解對方。",
            personal_values: "個人價值觀",
            skills_competencies: "技能與能力",
            personality_communication: "個性與溝通",
            personality_traits: "個性特質",
            communication_style: "溝通風格",
            role_focus: "角色重點",
            recent_challenges: "近期挑戰",
            activity_timeline: "活動時間軸",
            loading_happiness_data: "載入幸福感資料中…",
            happiness_history_90d: "90 天幸福感記錄",
            recent_happiness_suffix: " 的近期幸福感",
            happy_label: "開心：",
            okay_label: "普通：",
            not_great_label: "不太好：",
            recovery_progress: "恢復進度",
            risk_flags_summary: "風險訊號摘要",
            recent_timeline_label: "近期時間軸（最舊至最新）：",
            no_response: "沒有回應",
            happy: "開心",
            okay: "普通",
            not_great: "不太好",
            hover_load_happiness: "將游標移至此處以載入幸福感資料",
            happiness_icon_title: "檢視 90 天幸福感歷程，附風險與恢復洞察",
            star_performance_tooltip: "表現出眾，屬於該週獲得表揚者的前 15%",
            no_recent_data: "沒有近期資料",
            top_skills: "頂尖技能",
            top_skills_subtitle: "同儕意見回饋的獨特肯定次數",
            culture_add: "文化貢獻",
            culture_add_subtitle: "對表揚 #values 的貢獻",
            view_all: "查看全部",
            recognition_given: "送出的表揚",
            recognition_received: "收到的表揚",
            give_to_receive_ratio: "送出與接收比例",
            alignment_rating_score: "一致性評分",
            is_a_top: "屬於前",
            culture_add_contributor_suffix: "% 文化貢獻者",
        },
    },
    pincode: {
        your_verification: "你的驗證",
        enter_the_four: "請輸入傳送至你郵箱的 4 位數驗證碼",
        your_code_is: "驗證碼不正確，請再試一次…",
        you_have: "你還有",
        attempts_remaining: "次嘗試機會",
    },
    powerUp: {
        EXPORT: "匯出",
        Recognition_trends: "表揚趨勢",
        PARTICIPATION_RATE: "參與率",
        No_Filter: "無篩選",
        Select_all: "全選",
        Clear: "清除",
        Filter_power_up: "根據表揚價值篩選 Power-Ups 活動",
        Cancel: "取消",
        Okay: "確定",
        results_from: "結果來自",
        results: "結果",
        Export_Power_up_Activity: "匯出 Power-Ups 活動",
        Date_Range: "選擇開始及結束日期",
        Start_Date: "開始日期",
        End_Date: "結束日期",
        Recipient: "收件人",
        From: "來自",
        For: "給",
        Reward: "獎賞",
        Sent_on: "傳送於",
        Automations: "自動化",
        Preset_Library: "預設庫",
        By_Month: "按月",
        Automate: "自動化",
        By_Quarter: "按季",
        By_Year: "按年",
        Create_your_own: "自行建立",
        Recognition: "表揚",
        Power_up_Recipients: "Power-Ups 收件人",
        based_on_your_selection: "根據你的選擇",
        Preview_on_Mobile_Layout: "在手機版面預覽",
        got: "獲得",
        for: "因為",
        This_power_up_automation_has: "此 Power-Ups 自動化尚未啟用",
        This_power_up_automation_has_been: "此 Power-Ups 自動化已啟用",
        Recipients: "收件人",
        recipients: "收件人",
        Autogenerated: "自動產生",
        for_showing_time_period: "顯示時段為",
        Add: "新增",
        Values_optional: "價值觀（選填）",
        Select_values_optional: "選擇價值觀（選填）",
        Schedule: "排程",
        Following_work_day: "下一個工作日",
        Time: "時間",
        Select_time: "選擇時間",
        Now: "現在",
        Name_of_Recipient: "收件人姓名",
        Name_of_Recipient_s: "收件人姓名",
        Reason_for_recognition: "表揚原因",
        Reward_Type: "獎賞類型",
        Medal_Design: "獎章設計",
        Coin_Medal_or_Gem: "Coins、獎章或 Gems",
        Amount: "數量",
        Number_of_coins: "Coins 數量",
        Number_of_gems: "Gems 數量",
        Share_on_Activity_Feed: "分享至動態消息",
        SAVE_CHANGES: "儲存變更",
        DE_ACTIVATE_AUTOMATION: "停用自動化",
        ACTIVATE_AUTOMATION: "啟用自動化",
        SEND: "傳送",
        RESET: "重設",
        Duplicate: "複製",
        Delete: "刪除",
        performance: {
            select_teams: "選擇團隊",
            select_time_period: "選擇時段",
            performance_presets: "績效預設",
            performance_tracker: "績效追蹤",
            boosts_status: "Boosts 狀態",
            culture_add: "文化契合",
            goal_progress: "目標進度",
            active_filter: "已啟用篩選",
            clear_filter: "清除篩選",
            export: "匯出",
            no_matching_results: "找不到符合的結果",
            no_matching_results_desc: "找不到符合你目前篩選條件的資料。",
            try_one_of_these: "試試以下方法：",
            clear_all_filters: "清除所有篩選",
            manager: "經理",
            boosts_on_track: "Boosts 進度正常",
            both: "兩者",
            team_member: "團隊成員",
            goal_follow_up: "目標跟進",
            per_goal_ratings: "每項目標評分",
            culture_follow_up: "文化跟進",
            preset_name: "預設名稱",
            review_questions: "檢閱問題",
            goal_performance: "目標表現",
            culture_contribution: "文化貢獻",
            scheduling: "排程",
            next_review_period: "下一個檢閱週期",
            assignments: "指派",
            assign_to_teams: "指派給團隊",
            assign_members: "指派成員",
            boost_preview: "Boost 預覽",
        },
        activity: {
            total_recognition: "總表揚數",
            value_aligned: "符合價值觀",
            pct_value_aligned: "% 符合價值觀",
            participation_rate: "參與率",
            recognition_trends: "表揚趨勢",
            last_12_months: "過去 12 個月",
            total: "總數",
            values_aligned_hash: "#符合價值觀",
            values_heatmap: "價值觀熱度圖",
            show_all: "顯示全部",
            use: "使用",
            window: "時段",
            values: "價值觀",
            recognition_trends_data: "表揚趨勢資料",
            month: "月份",
            values_aligned: "符合價值觀",
            pct_values_aligned: "% 符合價值觀",
            export_csv: "匯出 CSV",
        },
        outbox_multiple: "多個",
        leaderboards: {
            all_recognition: "所有表揚",
            recognition_metrics: "表揚指標",
            recognition_metrics_sub: "同事之間的表揚活動",
            most_recognition_given: "最多表揚給予",
            most_recognition_given_sub: "同事表揚給予最多者",
            most_recognition_received: "最多表揚收到",
            most_recognition_received_sub: "同事表揚收到最多者",
            give_receive_ratio: "給予收到比最高",
            give_receive_ratio_sub: "每收到一次就給予最多同事表揚",
            alignment_metrics: "契合度指標",
            alignment_metrics_sub: "價值觀契合表現",
            alignment_given: "最強契合給予",
            alignment_given_sub: "最有效地強化你的價值觀",
            alignment_received: "最強契合收到",
            alignment_received_sub: "最契合你價值觀的行為",
            alignment_overall: "整體契合最強",
            alignment_overall_sub: "最佳文化及價值觀大使",
            see_full_list: "查看完整列表",
        },
    },
    questions: {
        add_a_question: "新增問題",
        preview_of_daily: "經理每日洞察預覽",
        summary_of_insights: "來自你直屬下屬的洞察摘要",
        of_ten_direct: "位直屬下屬（共 10 位）",
        responded: "已回應",
        yes: "是",
        average_rating_out: "平均分（滿分 10 分）",
        english: "英文",
        thai: "泰文",
        add_option: "新增選項",
        open_ended: "開放式",
        yes_or_no: "是／否",
        multiple_choice: "多項選擇",
        question: "問題",
        option: "選項",
        positive: "正面",
        neutral: "中立",
        negative: "負面",
        min_label: "最低標籤",
        max_label: "最高標籤",
        reward: "獎賞",
        power_skill: "Power Skill",
        frequency: "頻率",
        day_of_week: "星期幾",
        schedule: "排程",
        please_select_frequency: "請選擇頻率",
        and_when: "以及何時？",
        more: "更多",
        assign_a_sentiment: "指派情緒",
        coins: "Coins",
        select_power_skill: "選擇 Power Skill（選填）",
        how_often_do: "你希望多久發問此問題一次？",
        what_day_of: "你希望於星期幾發問此問題？",
        CALENDAR_VIEW: "行事曆檢視",
        Audience: "對象",
        Active: "啟用",
        Inactive: "停用",
        Show_All: "顯示全部",
        View: "檢視",
        Preview_of_Daily_Insights: "經理每日洞察預覽",
        Summary_of_insights_from: "來自你直屬下屬的洞察摘要",
        of_ten_direct_reports: "位直屬下屬（共 10 位）",
        responded_Yes: "回應「是」",
        average_rating_out_of: "平均分（滿分 10 分）",
        of_fifty_overal: "位（整體共 50 位）",
        English: "英文",
        Thai: "泰文",
        Positive: "正面",
        Neutral: "中立",
        Negative: "負面",
        Add_Option: "新增選項",
        Min_label: "最低標籤",
        Max_label: "最高標籤",
        Reward: "獎賞",
        Power_Skill: "Power Skill",
        Select_power_skill: "選擇 Power Skill（選填）",
        Day_of_Week: "星期幾",
        Please_select_frequency: "請選擇頻率",
        Schedule: "排程",
        Type: "類型",
        Select_Dimension: "選擇面向",
        Question_Format: "問題格式",
        Open_ended: "開放式",
        Yes_or_No: "是／否",
        Multiple_Choice: "多項選擇",
        Scale: "量表",
        Question: "問題",
        Option: "選項",
        Frequency: "頻率",
        Very_important: "非常重要",
        Coins: "Coins",
        Status: "狀態",
        Action: "操作",
        How_often__you: "你希望多久發問此問題一次？",
        What_day_of_week: "你希望於星期幾發問此問題？",
        Not_at_all: "完全不",
        QUESTION_DETAILS: "問題詳情",
        Search: "搜尋",
        Assign_a_Sentiment: "指派情緒",
        Category: "類別",
        Row_Header: "列標題",
        Row_Header_Placeholder: "代表此問題洞察的標題",
        preview_for_managers: "經理預覽",
        email_subject_today: "你團隊今天的洞察",
        today: "今天",
        three_insights: "3 項洞察",
        email_intro_shared: "以下是你團隊今天分享的內容。",
        caption_of_four_direct: "位直屬下屬（共 4 位）",
        caption_of_fourteen_overall: "位（整體共 14 位）",
        responded_word: "已回應",
        view_details: "檢視詳情",
        sample_response_placeholder: "團隊成員的範例回應會在收到回應後於此顯示。",
        youve_replied: "你已回覆",
        view_full_daily_report: "檢視完整每日報告",
        generate_placeholder: "我想了解大家對我們 #卓越 價值觀的理解程度",
        generate_question: "產生問題",
        send_to: "傳送給",
        follow_up: "跟進",
        program_only: "Program only",
        response_settings: "回應設定",
        rolling_response: "持續回應",
        rolling_response_tooltip: "持續保留直至此問題下一次發送，於收到回應前持續傳送",
        submit_responses_to_managers: "將回應提交給經理",
        private_feedback_mode: "私密意見模式",
        private_feedback_hint: "回應會對經理隱藏，只能以匿名意見形式檢視",
        report_card_analytics: "報告分析",
        include_in_report_card: "納入 洞察 → 報告",
        include_in_culture_index: "納入文化指數",
        culture_index_tooltip: "將此問題納入洞察儀表板所顯示的文化指數計算",
        refreshing: "正在重新整理……",
        refresh_calendar_title: "重新整理行事曆並選擇今天",
        legend_heavy_load: "繁重（>5 條問題）",
        legend_light_load: "輕量（<4 條問題）",
        legend_open_ended_questions: "開放式問題",
        dimension: "面向",
        delivery: "發送",
        essential_question_tooltip: "這是我們分析和報告的必要問題。可以在問題列表檢視中停用，但需確認。",
        toggle_off_tooltip: "關閉以將此問題從每日問題組合中移除（會影響重複項）",
        bi_weekly: "雙週",
        question_recipients: "問題收件人",
        team_label: "團隊",
        includes_child_teams: "包含子團隊的回應",
        all_teams: "所有團隊",
        filter_by_team: "按團隊篩選",
        search_teams_placeholder: "搜尋團隊……",
        no_teams_found: "找不到團隊",
        combined_responses_prefix: "顯示合併回應，來自",
        combined_responses_suffix: "及其子團隊",
        no_responses_available: "沒有可用回應",
        no_responses_for_team: "所選團隊沒有可用回應",
        summary: "摘要",
        ai_generated_note: "由 AI 根據所選日期前 3 個月內分享的意見產生",
        responses_label: "回應",
        add_follow_up_question: "新增跟進問題",
        select_placeholder: "選擇",
        SUBMIT: "提交",
        toast_include_row_header: "請為你的問題加入列標題",
        toast_input_option_prefix: "請輸入選項",
        toast_include_version_prefix: "請加入",
        toast_include_version_suffix: "版本的問題",
        toast_select_dimension: "請選擇面向",
        toast_select_question_format: "請選擇問題格式",
        toast_input_coins: "請輸入 Coins",
        toast_select_frequency: "請選擇頻率",
        toast_select_day_of_week: "請選擇星期幾",
        toast_select_schedule: "請選擇排程",
        toast_custom_question_created: "你的自訂問題已建立",
        question_saved: "問題已儲存",
        saved_follow_up_question: "跟進問題已儲存",
        saved_question_calendar_hint: "日曆已加入此問題。你可以查看它會出現的位置、新增另一個問題，或關閉此視窗。",
        saved_follow_up_question_hint: "此問題已儲存為跟進問題，因此會在由上層答案選項連結時出現，而不會直接顯示在日曆上。",
        saved_program_only_question: "Program-only question saved",
        saved_program_only_question_hint: "This was saved as a program-only question, so it will only fire when a program references it — not on the calendar.",
        view_in_calendar: "在日曆中查看",
        add_another_question: "新增另一個問題",
        done: "完成",
        saving_question: "儲存中...",
        toast_custom_question_create_failed: "未能儲存此問題，請再試一次。",
        toast_open_calendar_failed: "未能為此問題開啟日曆，請再試一次。",
        every: "每個",
        of_each_month: "每月",
        first: "第一個",
        second: "第二個",
        third: "第三個",
        fourth: "第四個",
        fifth: "第五個",
        toast_yes_no_assignment_required: "是／否問題必須將正面及負面分別指派給「是」或「否」選項，或為兩個選項指派中立。",
        toast_multi_choice_assignment_required: "多項選擇問題必須至少有一項正面及一項負面指派，或為所有選項指派中立。",
        toast_input_min_max_label: "請輸入最低／最高標籤",
    },
    register: {
        get_started_with: "開始使用 Happily",
        set_up_one: "設定 1 個團隊",
        FREE: "免費",
        BOOK_A_TIME: "預約時間",
        set_up_a: "為一個團隊設定 21 天免費試用，搭配",
        up_to_twenty: "最多 20 位使用者",
        set_up_many: "設定多個團隊",
        schedule_a_one: "與我們的團隊預約 1 對 1 會議",
        team_who_will: "團隊會確保你充分獲得",
        the_most_out: "Happily 的最大價值",
        Setting_up_your: "正在設定你的帳戶",
        help_us_get: "幫助我們更了解你及你的公司",
        your_name: "你的姓名",
        please_input_your_name: "請輸入你的姓名",
        your_work_email: "你的工作電郵",
        please_input_your_work: "請輸入你的工作電郵",
        please_input_correct_email: "請輸入正確的電郵",
        your_phone_number: "你的電話號碼",
        please_input_your_phone: "請輸入你的電話號碼",
        please_input_only_number: "請只輸入數字",
        company_name: "公司名稱",
        please_input_company: "請輸入公司名稱",
        Location: "地點",
        please_input_Location: "請輸入地點",
        Time_Zone: "時區",
        please_input_Time_Zonen: "請輸入時區",
        language_preference: "語言偏好",
        how_many_people: "人數",
        please_input_number_of: "請輸入員工人數",
        please_input_language: "請輸入語言偏好",
        what_would_you_like: "你希望透過 Happily 達成甚麼",
        please_input_your_achieve: "請輸入你希望達成的目標",
        i_agree_to: "我同意",
        terms_and_conditions: "條款及細則",
        verify_my_email: "驗證我的電郵",
        confirm_your_email: "確認你的電郵",
        we_sent_you: "我們已傳送電郵驗證碼到 ",
        the_email_may: "電郵可能需要 15-20 秒才送達，並會在 15 分鐘內過期",
        resend_code: "重新傳送驗證碼",
        go_back: "返回",
        book_a_meeting: "預約會議",
        i_want_to: "我希望打造更快樂的職場。",
        Schedule_a_time_with: "與我們預約時間",
        Setting_up_multiple_teams: "設定多個團隊透過匯入流程會更輕鬆，我們的團隊可引導你完成。預約會議後，我們會盡快（通常一小時內，最晚 24 小時）聯絡你，讓你順利上線！",
    },
    reports: {
        DAILY_REPORT_PREVIEW: "每日報告預覽",
        Select_a_Manager: "選擇經理",
        Select_date: "選擇日期",
        Delivery_Status: "發送狀態",
        Undelivered: "未送達",
        Delivered: "已送達",
        Issue: "問題",
        Read_Status: "閱讀狀態",
        Preview_a_report_by: "透過選擇經理及日期預覽報告",
        from_the_above_menu: "從上方選單",
        Loading: "載入中",
        Unable_to_preview_this: "由於資料不足，無法預覽此報告",
        MONTHLY_REPORT_PREVIEW: "每月報告預覽",
        Select_a_Person: "選擇人員",
        Select_month: "選擇月份",
        WEEKLY_REPORT_PREVIEW: "每週報告預覽",
        quarterly: {
            main: {
                report_generator: "報告產生器",
                scope_label: "範圍",
                scope_placeholder: "選擇範圍",
                company_wide: "全公司",
                quarter_label: "季度",
                quarter_placeholder: "選擇季度",
                generate_report: "產生報告",
                generating: "產生中…",
                loading_title: "正在產生你的報告",
                empty_title: "建立簡報",
                empty_text: "於上方選擇範圍及季度，然後點擊「產生報告」即可建立管理層簡報。",
                generated_reports: "已產生的報告",
                search_placeholder: "搜尋報告…",
                loading_reports: "載入報告中…",
                col_report_name: "報告名稱",
                col_quarter: "季度",
                col_created: "建立時間",
                col_updated: "最後更新",
                col_actions: "操作",
                view: "檢視",
                regenerate: "重新產生",
                delete: "刪除",
                no_search_results: "沒有報告符合你的搜尋。",
                no_reports_yet: "尚未產生任何報告。立即於上方建立！",
                back_to_config: "返回設定",
                pdf_title: "正在準備你的 PDF",
                pdf_tip: "大型報告可能需時較長",
            },
            controls: {
                previous_slide: "上一張",
                next_slide: "下一張",
                go_to_slide: "跳至投影片",
                generating_pdf: "產生 PDF 中…",
                download_pdf: "下載為 PDF",
                enter_fullscreen: "進入全螢幕",
                exit_fullscreen: "退出全螢幕",
            },
            viewer: {
                navigate: "導覽",
                fullscreen: "全螢幕",
                exit: "退出",
            },
            title_cover: {
                badge: "員工投入度",
                title: "季度報告",
            },
            closing: {
                contact_label: "有問題或意見？",
                contact_text: "聯絡你的 HR 團隊",
                next_steps: "下一步",
                generated: "產生於",
            },
            key_metric: {
                vs_last_quarter: "對比上季",
            },
            highlights: {
                strengths_title: "優勢",
                strengths_subtitle: "表現良好的範疇",
                challenges_title: "挑戰",
                challenges_subtitle: "需要關注的範疇",
                priorities_title: "優先事項",
                priorities_subtitle: "建議關注的範疇",
                empty_strengths: "未發現優勢",
                empty_challenges: "未發現挑戰",
                empty_priorities: "未發現優先事項",
            },
            chart_callouts: {
                key_insights: "關鍵洞察",
                improvements: "改善項目",
                areas_of_concern: "關注範疇",
            },
            focus_alignment: {
                default_title: "按目標劃分的焦點",
                default_subtitle: "團隊如何將焦點與組織目標對齊",
                items: "項目",
                done: "完成",
                open: "進行中",
                people: "人",
                unmatched_items: "未配對項目",
                not_linked: "未連結至任何目標",
                consider_linking: "建議將這些項目連結至目標",
                unknown_items: "一致性未知",
                no_goals_set: "此範圍尚未設定目標",
                set_goals_to_assess: "設定目標以評估一致性",
                empty_text: "本季沒有正在進行的目標焦點",
            },
            goal_distribution: {
                items: "項目",
                done_suffix: "% 完成",
                legend_completed: "已完成",
                legend_in_progress: "進行中",
                empty_text: "本季沒有正在進行的目標焦點",
            },
            leaderboard: {
                empty_text: "此期間沒有可用資料",
            },
            question_scores: {
                legend_excellent: "70%+ 優秀",
                legend_moderate: "50-69% 中等",
                legend_attention: "<50% 需要關注",
            },
            recommendations: {
                ai_badge: "AI 驅動洞察",
                default_title: "關鍵建議",
                default_subtitle: "推動投入度與績效的策略性行動",
                high_priority: "高優先",
                medium: "中等",
                low: "低",
                high_impact: "高影響",
                generated_by: "由 Happily.ai 產生",
            },
            who5: {
                label_poor: "不佳",
                label_good: "良好",
                legend_0: "0 - 從來沒有",
                legend_1: "1 - 少部分時間",
                legend_2: "2 - 少於一半時間",
                legend_3: "3 - 多於一半時間",
                legend_4: "4 - 大部分時間",
                legend_5: "5 - 所有時間",
            },
        },
    },
    rewards: {
        redeemed: "已兌換",
        add_a_reward: "新增獎賞",
        active: "啟用",
        inactive: "停用",
        show_all: "顯示全部",
        status: "狀態",
        coins: "Coins",
        gems: "Gems",
        edit: "編輯",
        Reward: "獎賞",
        Activity: "活動",
        preview_on_mobile: "在手機版面預覽",
        REDEEM: "兌換",
        REQUEST: "申請",
        english: "英文",
        thai: "泰文",
        name: "名稱",
        name_of_reward: "獎賞名稱",
        mame_of_reward_Thai: "獎賞名稱（泰文）",
        description: "描述",
        description_Thai: "描述（泰文）",
        cost: "費用",
        duration: "期間",
        start_date: "開始日期",
        end_date: "結束日期",
        gift_cards: "禮品卡",
        perks: "優惠",
        team_building: "團隊建立",
        doing_good: "行善",
        settings: "設定",
        country: "國家／地區",
        all_countries: "所有國家／地區",
        limited_qty: "限量",
        available: "可用",
        no_limit: "無限制",
        Require_Approval: "需審批",
        On: "開",
        Off: "關",
        image: "圖片",
        upload: "上載",
        file_size_should: "檔案尺寸應為 600 x 320 px。獎賞縮圖會自動以中央方形產生。",
        reward: "獎賞",
        processing: "處理中",
        sent: "已傳送",
        cancel: "取消",
        confirm_cancellation: "確認取消",
        are_you_sure: "你確定要取消",
        redeemed_by: "兌換者（贈予）",
        Recipient: "收件人",
        Value: "價值",
        Type: "類型",
        Date_and_Time: "日期及時間",
        Delivered: "已送達",
        no: "否",
        yes_and_refund: "是，並退款",
        yes_and_do: "是，並不退款",
        refund: "取消並退款",
        all_countries_label: "所有國家／地區",
        member_countries_only: "只限成員所在國家／地區",
        enabled: "已啟用",
        disabled: "已停用",
        show_all_status: "顯示所有狀態",
        bulk_update_rates: "批次更新匯率",
        bulk_update_coin_rates: "批次更新 Coins 匯率",
        gem_exchange: "寶石兌換",
        gem_exchange_editor: {
            title: "寶石兌換",
            subtitle: "讓員工將 Gems 兌換為 Coins。",
            enabled: "已啟用",
            disabled: "已停用",
            shared_metadata: "共用中繼資料",
            display_name: "顯示名稱",
            display_name_hint: "自動產生 — 可編輯自訂。",
            image: "圖片",
            image_default_hint: "使用預設 — 上載以自訂。",
            upload_image: "上載圖片",
            replace_image: "更換圖片",
            use_default: "使用預設",
            image_hint: "JPG 或 PNG，最大 2MB。",
            duration: "期間",
            templates: "範本",
            templates_hint_prefix: "使用",
            templates_hint_and: "及",
            templates_hint_suffix: "以插入級別數值。",
            exchange_tiers: "兌換級別",
            exchange_tiers_hint: "每個級別會成為「優惠」分頁中的一項獎賞。",
            col_gems: "Gems",
            col_coins: "Coins",
            col_rate: "匯率",
            per_gem: "每 gem",
            best_value: "最划算",
            add_another_tier: "新增另一級別",
            employee_preview: "員工預覽",
            employee_preview_hint: "級別 1 於兌換時的顯示。",
            save_changes: "儲存變更",
        },
        tiers_active: "個級別已啟用",
        tier_active: "個級別已啟用",
        no_tiers_yet: "尚未有級別",
        off: "關",
        gem_exchange_on_add_tiers: "寶石兌換已開啟。新增級別讓員工可兌換。",
        gem_exchange_intro: "讓員工透過可設定的級別，將 Gems 兌換成 Coins。",
        edit_tiers: "編輯級別",
        configure_arrow: "設定 →",
        set_up_arrow: "開始設定 →",
        new_badge: "新",
        expired_badge: "已過期",
        managed: "由系統管理",
        managed_by_gem_exchange: "由寶石兌換管理",
        edit_a_reward: "編輯獎賞",
        linked_gem_variant: {
            create_title: "建立寶石版本", edit_title: "編輯寶石版本",
            subtitle: "新增寶石價格，同時保留金幣版本。",
            provider_linked: "已連結供應商", coin_version_kept: "金幣版本保持啟用", gem_version: "寶石版本",
            gem_cost: "寶石費用", gem_cost_placeholder: "輸入所需寶石",
            gem_cost_help: "會員使用寶石，帳單仍使用原本卡值和供應商。",
            create_action: "建立寶石版本", add_action: "新增寶石版本", edit_action: "編輯寶石版本",
            keep_coin_help: "現有金幣版本仍然可用。", created: "寶石版本已建立，金幣版本沒有變更。", updated: "寶石版本已更新。", save_failed: "無法儲存寶石版本。",
            errors: {
                missing_source_reward: "找不到公司獎賞。", missing_master_reward: "找不到原始供應商獎賞。",
                invalid_gem_cost: "請輸入大於零的整數寶石費用。", inactive_master_reward: "原始供應商獎賞未啟用。",
                missing_reward_name: "原始獎賞缺少名稱。", missing_reward_type: "原始獎賞缺少發送類型。",
                missing_face_value: "原始獎賞缺少可計費面值。", missing_reward_currency: "原始獎賞缺少貨幣。",
                missing_provider_product_id: "缺少供應商產品 ID。", unable_to_create_variant_id: "無法建立安全的獎賞 ID。"
            }
        },
        type_placeholder: "類型",
        reward_activity: "獎賞活動",
        reward_activity_view: "獎賞活動檢視",
        loading_activity: "正在載入獎賞活動",
        updating_activity: "正在更新活動…",
        loading_activity_hint: "較長的日期範圍可能需要多一點時間。載入期間你可以關閉此視窗。",
        activity_load_error: "無法載入獎賞活動",
        activity_load_error_hint: "請檢查連線後再試一次。你的獎賞資料並未更改。",
        activity_empty: "此期間沒有獎賞活動。",
        delivered: "已送達",
        recipients: "收件人",
        members: "成員",
        pending: "待處理",
        transactions: "交易",
        member_spend: "成員獎賞支出",
        member: "成員",
        redeemed_by_member: "兌換者",
        redemptions: "兌換次數",
        reward_spend: "獎賞支出",
        share_of_currency_spend: "佔該貨幣支出",
        last_activity: "最近活動",
        member_spend_hint: "已送達的獎賞支出會歸入兌換成員，包括送給其他人的禮物。",
        member_spend_empty: "此期間沒有已送達的獎賞支出。",
        currency_totals_separate: "不同貨幣分開計算，確保總額準確。",
        currency_count: "{count} 種貨幣",
        delivered_reward_spend: "已送達獎賞支出",
        delivered_reward_spend_period: "已送達獎賞支出 · {period}",
        custom_date_range: "自訂日期範圍",
        export: "匯出",
        value: "價值",
        type: "類型",
        date_and_time: "日期及時間",
        date_range: "日期範圍",
        to: "至",
        start_date_placeholder: "開始日期",
        end_date_placeholder: "結束日期",
        confirm_and_filter: "確認並篩選",
        currency: "貨幣",
        select_currency: "選擇貨幣",
        current_rate: "現時匯率",
        new_rate: "新匯率",
        preview_changes: "預覽變更",
        show_only_changes: "只顯示變更",
        reward_name: "獎賞名稱",
        current: "現時",
        new_coins: "新 Coins",
        change: "變更",
        no_rewards_for_currency: "找不到所選貨幣的獎賞。",
        select_currency_hint: "選擇貨幣以檢視及更新獎賞。",
        apply: "套用",
        changes_suffix: "項變更",
        change_singular: "變更",
        of: "／",
        toast_managed_by_gem_exchange: "由寶石兌換管理 — 請使用「編輯級別」啟用／停用。",
        toast_confirm_activate: "你確定要啟用此獎賞嗎？",
        toast_reward_activated: "獎賞已啟用",
        toast_canceled: "已取消",
        toast_confirm_disable: "你確定要停用此獎賞嗎？",
        toast_reward_disabled: "獎賞已停用",
        toast_select_valid_date_range: "請選擇有效的日期範圍",
        toast_confirm_cancel_transaction: "你確定要取消此獎賞交易嗎？",
        toast_transaction_canceled: "獎賞已成功取消",
        toast_coins_gems_refunded_prefix: "Coins 或 Gems 將退還給",
        toast_confirm_status_change: "你確定要變更此項目的狀態嗎？",
        toast_status_updated: "狀態已更新",
        toast_select_image: "請選擇圖片",
        toast_confirm_delete: "你確定要刪除此獎賞嗎？",
        toast_reward_deleted: "獎賞已刪除",
        toast_reward_added: "獎賞已成功新增",
        toast_reward_updated: "獎賞已更新",
        toast_avatar_format_error: "頭像圖片必須為 JPG 格式！",
        toast_avatar_size_error: "頭像圖片大小不得超過 2MB！",
    },
    sparks: {
        custom_sparks: "自訂 Sparks",
        program_only: "Program only",
        Create_a_Set: "建立套裝",
        Set: "套裝",
        HAPPILY_S_SPARKS: "HAPPILY 的 SPARKS",
        Name_of_Spark_Set: "Spark 套裝名稱",
        Please_input_Set_Name: "請輸入套裝名稱",
        Display_After: "顯示於之後",
        Before_Set_one: "第 1 套裝之前",
        Audience: "受眾",
        Set_name: "套裝名稱",
        Select: "選擇",
        SAVE_CHANGES: "儲存",
        CANCEL: "取消",
        DELETE_SPARK_SET: "刪除 SPARK 套裝",
        CREATE_SET: "建立套裝",
        Title: "標題",
        Edit: "編輯",
        Draft: "草稿",
        Create_a_New_Card: "建立新卡片",
        Spark_Title: "Spark 標題",
        Please_input_Spark_Title: "請輸入 Spark 標題",
        Spark_Icon: "Spark 圖示",
        Spark_Content_English: "Spark 內容 - 英文",
        Spark_Content_Thai: "Spark 內容 - 泰文",
        SAVE_SPARK: "儲存 SPARK",
        DELETE: "刪除",
        nudges: "Nudges",
        nudges_col_dimension: "維度",
        nudges_col_nudge: "Nudge",
        nudges_col_recipient: "接收者",
        nudges_col_date_time: "日期及時間",
        nudges_expand_all: "展開套裝中所有項目",
        nudges_hide_all: "收合套裝中所有項目",
        nudges_load_more: "載入更多",
        new_spark_set: "新的 Spark 套裝",
        ai_placeholder: "你希望就甚麼技能或知識建立微學習？",
        generate_spark_set: "生成 Spark 套裝",
        untitled: "未命名",
        spark_content_prefix: "Spark 內容 -",
    },
    demomode: {
        demo_on: "演示模式已開啟",
        demo_tooltip: "用戶名稱與團隊名稱會被遮蔽。請前往設定查看更多資訊。",
        detected_title: "我們偵測到你自上次登入後持續開啟演示模式。",
        detected_sub: "別擔心，我們會在頁面重新整理期間保持開啟。",
        warning: "警告：報告中顯示的姓名與細節不會被遮蔽",
    },
    sso: {
        your: "你的",
        this_account: "此帳戶",
        has_been_set: "已設定為使用 single sign-on",
        google_sign_In: "Google Sign-In",
        sign_In: "登入",
        sign_Out: "登出",
        mobile_welcome_to: "歡迎使用",
        mobile_account_set_to_login: "你的帳戶已設定為透過 SSO 登入",
    },
    performance: {
        focus_areas: {
            select_team: "選擇團隊",
            all_teams: "所有團隊",
            search: "搜尋",
            without_focus: "沒有重點",
            with_partners: "有夥伴",
            goal_alignment: "目標對齊",
            all_items: "所有項目",
            with_goal: "有目標",
            without_goal: "沒有目標",
            people: "人員",
            total: "總計",
            with_focus: "有重點",
            no_focus: "沒有重點",
            focus_coverage_trend: "重點覆蓋趨勢",
            last: "過去",
            weeks: "週",
            days: "天",
            focus_items: "重點項目",
            unique: "不重複",
            open: "進行中",
            done: "已完成",
            focus_insights: "重點洞察",
            focus_distribution: "重點分布",
            in_progress: "進行中",
            completed: "已完成",
            team_metrics: "團隊指標",
            team: "團隊",
            tooltip_total_people: "此團隊的總人數",
            tooltip_focusing: "擁有至少一個重點項目的人員百分比",
            focusing: "專注中",
            tooltip_items_open_done: "進行中項目數量／已完成項目數量",
            items_open_done: "項目（進行中／完成）",
            tooltip_completion: "已標記為完成的重點項目百分比",
            completion: "完成率",
            tooltip_partnership: "至少有一位夥伴的重點項目百分比",
            partnership: "夥伴合作",
            no_results_found: "找不到結果",
            no_focus_data_available: "沒有重點資料",
            adjust_filters_hint: "請嘗試調整篩選條件或搜尋字詞",
            empty_state_hint: "當人員開始設定重點領域時，將顯示於此",
            no_focus_items: "沒有重點項目",
            no_items_in_progress: "沒有進行中的項目",
            no_completed_items: "沒有已完成的項目",
            focus_item_details: "重點項目詳情",
            focus_item_label: "重點項目",
            description_label: "描述",
            status_label: "狀態",
            focus_partners: "重點夥伴",
            no_partners_for_item: "此重點項目沒有夥伴",
            partners_view: "夥伴的檢視：",
            your_view: "你的檢視：",
        },
        emergent_goals: {
            discover_goals: "探索目標",
            header_subtitle: "由 AI 從未配對工作中提供的建議",
            run_fresh_analysis: "執行新的 AI 分析",
            refresh: "重新整理",
            close: "關閉",
            loading_hint: "通常需時 30-60 秒",
            try_again: "再試一次",
            all_caught_up: "已全部處理",
            all_caught_up_desc: "未配對的重點項目中沒有發現明顯模式。團隊的工作可能已與現有目標對齊。",
            auto_matched_desc: "重點項目已自動配對至現有目標",
            hide: "隱藏",
            show: "顯示",
            review_matches: "檢視配對",
            matches_need_confirmation: "這些配對需要你確認",
            focus_item: "重點項目",
            suggested_goal: "建議目標",
            accept: "接受",
            skip: "略過",
            matched: "已配對",
            skipped: "已略過",
            suggested_new_goals: "建議的新目標",
            new_goals_desc: "從未配對工作的模式中發掘的新目標",
            team: "團隊",
            recommended: "推薦",
            select_team: "選擇團隊",
            link_to_parent: "連結至上層目標",
            optional: "選填",
            select_parent_goal: "選擇上層目標",
            no_ancestor_goals: "沒有可選的上層團隊目標",
            create_goal: "建立目標",
            created: "已建立",
            done: "完成",
        },
        talent_matrix: {
            select_team: "選擇團隊",
            all_teams: "所有團隊",
            x_axis: "X 軸",
            y_axis: "Y 軸",
            swap_axes: "交換軸線",
            color_by_talent_type: "按人才類型著色",
            color_by_team: "按團隊著色",
            no_coloring: "不著色",
            export_csv: "匯出 CSV",
            higher_is_better: "數值越高越好",
            lower_is_better: "數值越低越好",
            employee_details: "員工詳情",
            employees: "員工",
            employee: "員工",
            network: "人際網絡",
            talent_type: "人才類型",
            quadrant: "象限",
            engagement_wellbeing: "投入度與身心健康",
            happiness_score: "幸福感分數",
            engagement_score: "投入度分數",
            flight_risk: "離職風險",
            performance_growth: "績效與成長",
            impact_rating: "影響力評分",
            performance_score: "績效分數",
            focus_score: "重點分數",
            goal_alignment: "目標對齊",
            recognition_trust: "表揚與信任",
            trust_score: "信任分數",
            peer_trust_count: "同儕信任次數",
            giving_recognition: "給予表揚",
            receiving_recognition: "獲得表揚",
            medals: "獎章",
            power_skills_eq: "Power Skills (EQ)",
        },
        goals: {
            search_members: "搜尋成員",
            include_subteams: "包含子團隊",
            include_subteams_tooltip: "啟用後，重點對齊統計會包含所有子團隊",
            show_archived: "顯示已封存",
            show_archived_tooltip: "顯示已被軟刪除並封存的目標",
            krs_by_team: "按團隊查看 KRs",
            krs_by_individual: "按個人查看 KRs",
            goal_alignment_tooltip: "連結至團隊目標的重點項目百分比",
            expand_teams_to_load: "展開團隊以載入",
            aligned: "已對齊",
            unaligned: "未對齊",
            unknown: "未知",
            unknown_items: "一致性未知的焦點項目",
            focus_items_alignment_unknown: "個焦點項目的一致性未知，因為尚未設定目標",
            focus_items_not_aligned: "個焦點項目未與任何目標對齊",
            no_goals_to_map: "沒有可對應的目標",
            members_with_krs: "擁有 KRs 的成員",
            total_krs: "KRs 總數",
            assigned: "已指派",
            avg_progress: "平均進度",
            kr_status: "KR 狀態",
            on_track: "依計劃進行",
            at_risk: "有風險",
            off_track: "偏離計劃",
            goal_focus_trends: "目標重點趨勢",
            hide_items: "隱藏項目",
            view_items: "檢視項目",
            has_value: "有數值",
            no_value: "無數值",
            no_teams_found: "找不到團隊",
            no_teams_available: "沒有團隊",
            no_teams_adjust_filters: "請嘗試調整搜尋字詞或篩選條件",
            no_teams_empty_hint: "團隊建立後將顯示於此",
            col_team: "團隊",
            col_goals: "目標",
            goal_name_placeholder: "目標名稱",
            save_changes: "儲存",
            archived: "已封存",
            edit_goal: "編輯目標",
            archive_goal: "封存目標",
            restore_goal: "還原目標",
            delete_permanently: "永久刪除",
            no_focus_on_goal_tooltip: "沒有人專注於此目標",
            linked_to_parent_goals: "已連結至上層目標：",
            goal_description_placeholder: "目標描述",
            goal_edit_hint: "請於上方編輯目標描述。使用頂部的儲存按鈕以確認變更。",
            key_results: "Key Results",
            ai_suggest_krs_tooltip: "由 AI 建議可量度的 Key Results",
            add_kr_manually_tooltip: "手動新增 Key Result",
            no_kr_empty_hint: "新增可量度的 Key Results 以追蹤進度",
            new_key_result: "新 Key Result",
            kr_title_placeholder: "Key Result 標題",
            start: "起始",
            target: "目標值",
            unit: "單位",
            unit_placeholder: "例如 %",
            owners: "負責人",
            assign_members_placeholder: "指派團隊成員",
            teams_group_label: "團隊",
            people_group_label: "人員",
            tracking_mode: "追蹤模式",
            tracking_collaborative: "協作 — 共享進度",
            tracking_individual: "個人 — 每人獨立",
            tracking_collaborative_hint: "所有人共同貢獻同一個數字",
            tracking_individual_hint: "每人各自追蹤自己的進度",
            tracking_individual_decreasing_warning: "個人追蹤會將每位負責人的數值相加，當目標低於起點時並不適用。",
            tracking_decreasing_reframe_hint: "考慮改為遞增的指標 — 例如「將留存率提升至 80%」而非「將流失率降至 20%」。",
            targets_per_owner: "每位負責人的目標",
            owner_targets_match: "個人目標合計 {sum} ／ 團隊目標 {team}",
            owner_targets_short: "個人目標合計 {sum} — 團隊目標為 {team}（短缺 {delta}）",
            owner_targets_over: "個人目標合計 {sum} — 團隊目標為 {team}（超出 {delta}）",
            owner_target_reset_tooltip: "重設為預設分配",
            owner_target_customized_hint: "自訂目標",
            owner_target_customized_tag: "自訂",
            owner_targets_match_action: "將團隊目標設為 {sum}",
            cycle: "週期",
            cycle_placeholder: "長期（無週期）",
            add_key_result: "新增 Key Result",
            parent_goal_links: "上層目標連結",
            edit_links: "編輯連結",
            add_links: "新增連結",
            no_parent_links_yet: "尚未連結任何上層目標",
            people_focusing_on_goal: "專注於此目標的人員：",
            no_members_found: "找不到成員",
            no_members_available: "沒有成員",
            select_team_to_view: "請選擇團隊以檢視成員的 KRs",
            krs_label: "KRs",
            no_krs_assigned: "未指派任何 KRs",
            tab_freeform: "自由輸入",
            tab_advanced: "進階",
            freeform_description: "以自由文字輸入目標。AI 會將其整理為個別目標並附上描述。",
            advanced_description_existing: "編輯現有目標或新增目標。",
            advanced_description_new: "直接新增含標題及描述的目標，無需 AI 轉換。",
            goal_label: "目標",
            existing: "現有",
            new: "新增",
            goal_title_placeholder: "目標標題（例如：提升客戶滿意度）",
            goal_description_optional_placeholder: "描述（選填 - 提供此目標的更多細節）",
            link_to_parent_goals: "連結至上層目標",
            linked: "已連結",
            select_parent_goals_placeholder: "選擇要對齊的上層目標…",
            no_parent_team_goals: "沒有可連結的上層團隊目標",
            add_another_goal: "新增另一個目標",
            link_subtitle: "將此目標與更高層級的 Objectives 對齊",
            current_goal: "目前目標",
            no_parent_goals_available: "沒有可用的上層目標",
            no_parent_goals_desc: "上層團隊需先建立目標，才能建立對齊連結。",
            select_parent_goals: "選擇上層目標",
            links: "連結",
            link_noun: "連結",
            remove_all_links: "移除所有連結",
            toast_updated: "目標更新成功",
            toast_update_failed: "目標更新失敗",
            toast_archived: "目標封存成功",
            toast_archive_failed: "目標封存失敗",
            toast_restored: "目標還原成功",
            toast_restore_failed: "目標還原失敗",
            toast_deleted: "目標已永久刪除",
            toast_delete_failed: "目標刪除失敗",
            kr_cycle: "週期",
            kr_cycle_placeholder: "長期",
            kr_start: "起始",
            kr_target: "目標值",
            kr_unit: "單位",
            kr_collaborative: "協作",
            kr_individual: "個人",
            kr_status_on_track: "依計劃進行",
            kr_status_at_risk: "有風險",
            kr_status_off_track: "偏離計劃",
            kr_status_completed: "已完成",
            kr_search_team_or_member: "搜尋團隊或成員",
            kr_teams_section: "團隊",
            kr_people_section: "人員",
            kr_no_members_found: "找不到成員",
            kr_clear_all: "全部清除",
            kr_note_placeholder: "備註（選填）",
            kr_status_auto: "自動（根據進度）",
            kr_status_manual_dot_tooltip: "狀態由 {name} 手動設定",
            kr_status_manual_dot_tooltip_unknown: "狀態已手動設定",
            kr_meta_updated_by: "由 {name} 於 {time} 更新",
            kr_meta_updated_auto: "於 {time} 自動更新",
            kr_meta_updated: "於 {time} 更新",
            kr_history_title: "更新記錄",
            kr_history_empty: "尚無更新",
            kr_history_show_all: "顯示全部 {count} 筆更新",
            kr_history_automation_actor: "自動化",
            kr_history_team_total: "團隊總計 {value}",
            kr_history_unknown_actor: "未知",
            kr_detail_eyebrow: "Key Result",
            kr_detail_of_target: "目標達成率",
            kr_detail_delta_since: "自上次更新 {delta}",
            kr_detail_chart_title: "進度趨勢",
            kr_detail_chart_empty: "更新次數尚不足以繪製圖表 — 每次進度更新都會顯示在這裡。",
            kr_detail_target_label: "目標",
            kr_detail_owners: "負責人",
            kr_detail_no_owners: "尚未指派負責人",
            kr_detail_automation: "自動化",
            kr_detail_last_synced: "最近同步於 {time}",
            kr_detail_last_checked: "最近檢查於 {time}",
            kr_detail_awaiting_sync: "等待首次同步",
            kr_detail_automation_paused: "自動化已暫停",
            kr_detail_cadence_daily: "每天 {time} 執行",
            kr_detail_cadence_weekly: "每週{day} {time} 執行",
            kr_detail_cadence_monthly: "每月 {dayOfMonth} 日 {time} 執行",
            kr_detail_reconnect: "重新連接",
            kr_detail_edit_automation: "編輯自動化",
            kr_detail_pause_automation: "暫停",
            kr_detail_resume_automation: "繼續",
            kr_detail_delete_automation: "刪除",
            kr_detail_update_progress: "更新進度",
            kr_detail_edit_kr: "編輯 Key Result",
            kr_detail_save_update: "儲存更新",
            suggest_kr_title: "建議 Key Results",
            suggest_kr_subtitle: "由 AI 為你的目標提供可量度的成果",
            run_fresh_ai_analysis: "執行新的 AI 分析",
            refresh: "重新整理",
            kr_loading_hint: "通常需時 15-30 秒",
            try_again: "再試一次",
            no_suggestions_title: "沒有可用的建議",
            no_suggestions_desc: "請嘗試為目標描述增加細節，或將更多重點項目對齊至此目標。",
            goal_context: "目標背景",
            kr_added: "已新增",
            kr_skipped: "已略過",
            kr_confidence: "信心度",
            kr_ai_reasoning: "AI 推理",
            kr_owner: "負責人",
            kr_assign_later: "稍後指派",
            kr_skip: "略過",
            kr_accept: "接受",
            toast_confirm_delete_kr: "刪除此 key result？此操作無法復原。",
            toast_delete_kr_title: "刪除 Key Result",
            toast_confirm_delete_automation: "刪除此自動化？Key Result 及更新記錄會保留，但自動更新將會停止。",
            toast_delete_automation_title: "刪除自動化",
            toast_automation_paused: "自動化已暫停",
            toast_automation_resumed: "自動化已繼續",
            toast_automation_deleted: "自動化已刪除",
            toast_automation_update_failed: "無法更新自動化",
            toast_automation_delete_failed: "無法刪除自動化",
            toast_add_at_least_one_goal: "請至少新增一個附有標題的目標",
            toast_goal_title_too_long: "目標標題不得超過 30 個字元",
            toast_goals_saved_successfully: "目標儲存成功",
            toast_no_data_to_export: "沒有可匯出的資料",
            toast_goal_title_too_long_single: "目標標題不得超過 30 個字元",
            toast_confirm_save_changes: "確定要儲存此目標的變更嗎？",
            toast_confirm_changes_title: "確認變更",
            toast_failed_to_update_goal: "目標更新失敗",
            toast_confirm_archive: "確定要封存此目標嗎？之後可從「顯示已封存」檢視中還原。",
            toast_archive_title: "封存目標",
            toast_confirm_restore: "確定要還原此目標嗎？它將顯示於活躍目標列表中。",
            toast_restore_title: "還原目標",
            toast_confirm_delete_goal: "確定要永久刪除此目標嗎？此操作無法復原。",
            toast_delete_goal_title: "刪除目標",
            toast_goal_linked_prefix: "Goal linked to",
            toast_goal_linked_suffix: "parent goal(s)",
            toast_parent_links_removed: "Parent goal links removed",
            toast_failed_update_goal_links: "Failed to update goal links",
        },
    },
    settings: {
        page_title: "設定",
        page_description: "管理全公司的功能、通訊與體驗",
        save_changes: "儲存變更",
        undo: "復原",
        changes_banner: "你已變更設定",
        tab_general: "一般設定",
        tab_performance: "績效檢討",
        tab_values: "技能與價值觀",
        tab_village: "Happily Village",
        tab_email_notifications: "電郵通知",
        section_general: "公司與通訊",
        section_general_description: "管理公司資料、傳送排程、假期、動態偏好、私隱及支援存取權。",
        company_name: "公司名稱",
        pulse_report_schedule: "Pulse 與報告排程",
        pulse_report_schedule_description: "設定問題與報告傳送至團隊的時間",
        daily_pulse: "Daily Pulse",
        daily_insights: "每日洞察",
        weekly_insights: "每週洞察",
        monthly_insights: "每月洞察",
        company_holidays: "公司假期",
        company_holidays_description: "Daily Pulse 問題會在即將到來的公司假期暫停",
        add_holidays: "新增假期",
        personal_holiday_presets: "個人假期預設",
        personal_holiday_presets_description: "建立團隊或成員專屬的假期排程，於個別休假日暫停 Daily Pulse 問題",
        set_personal_holiday: "設定個人假期",
        activity_feed_names: "動態名稱顯示",
        activity_feed_names_description: "啟用時，動態列會顯示暱稱（如有）。停用時則會改用名字。",
        use_nicknames_in_activity_feed: "在動態中使用暱稱",
        activity_feed_rewards: "獎賞活動",
        activity_feed_rewards_description: "啟用時，獎賞兌換會顯示在動態中。關閉以隱藏獎賞兌換活動。",
        show_reward_redemptions_in_activity_feed: "在動態中顯示獎賞兌換",
        allow_cross_location_gift_rewards: "允許跨地區禮品獎賞",
        allow_cross_location_gift_rewards_description: "讓員工向其他國家或地區的同事送出禮品獎賞。如果收件人可能無法兌換本地獎賞，系統仍可能顯示提示。",
        happily_assistance: "Happily 協助",
        happily_assistance_description: "允許 Happily 團隊存取你的主控台，以協助管理帳戶並提供建議。",
        happily_assist_access: "Happily Assist 存取權",
        demo_mode: "演示模式",
        demo_mode_description: "啟用演示模式時，所有頁面中與現有成員相關的用戶名稱、電郵、團隊及頭像都會被模糊處理。請謹慎使用，部分元素可能未完全遮蔽。",
        enable_demo_mode: "啟用演示模式",
        section_performance: "檢討與回饋",
        section_performance_description: "管理經理檢討工具、檢討狀態時限及反思提示。",
        enable_performance_boosts: "啟用 Performance Boosts",
        enable_performance_boosts_description: "Performance Boosts 讓經理可以透過 Gems 獎勵提供結構化的回饋與表揚，這些資料會計入員工的 Impact Rating。",
        performance_boosts: "Performance Boosts",
        performance_boost_notice: "Performance Boost 通知",
        performance_boost_notice_description: "設定經理提供績效檢討的最佳排程",
        pending_after: "待處理時間達",
        overdue_after: "逾期時間達",
        ai_reviewed_feedback: "AI 審閱回饋",
        reset_monthly: "每月重設",
        section_values: "表揚與同儕回饋",
        section_values_description: "設定同事表揚及提供回饋時使用的價值觀與技能。",
        recognition_values: "表揚價值觀",
        recognition_values_description: "同事及經理的表揚可引導或強制對齊公司的特定價值觀，並在表揚互動中以主題標籤呈現",
        new_value: "新增價值觀",
        peer_feedback: "同儕回饋",
        peer_feedback_description: "每月初，每位成員最多可挑選 2 人收取其回饋。提供回饋時，評審可選擇以下標籤代表對方「擅長」的項目：",
        peer_feedback_interactions: "同儕回饋互動",
        new_skill: "新增技能",
        section_village: "存取與參與",
        section_village_description: "管理 Village 存取權、House 計分、討論權限及 AI 生成主題。",
        village_access: "Village 存取權",
        village_access_description: "所有成員都可以使用 Happily Village 的互動，透過 Running Track、University、Houses 等促進健康、學習與協作！",
        happily_village_access: "Happily Village 存取權",
        fair_play_boost: "Battle Stadium Fair Play Boost",
        fair_play_boost_description: "當各 House 人數明顯不同時平衡 House Score。個人 XP 和任務排行榜不會調整。",
        fair_play_boost_enabled_note: "已啟用。系統會在下星期一的任務開始時檢查 House 人數，進行中的任務不會改變。",
        fair_play_boost_disabled_note: "已停用。House Score 將使用標準計分方式，變更會在下星期一的任務生效。",
        topic_creation_permissions: "主題建立權限",
        topic_creation_permissions_description: "控制誰可在 Town Hall 發起討論。限制時僅公司管理員可建立新主題，所有員工仍可參與現有討論。",
        allow_employee_topic_creation: "允許員工建立主題",
        town_hall_agent: "Town Hall Agent",
        town_hall_agent_description: "以 AI 驅動的話題引子提升職場討論。Town Hall Agent 會根據你選定的主題建立引人投入的話題與投票，促進有意義的對話與員工投入度。",
        performance_conversations: "績效對話",
        performance_conversations_description: "更新 Key Result 後，邀請員工作簡短反思，開啟與經理的對話。內容只會傳送給經理，時間線只顯示中性摘要。",
        add_theme: "新增主題",
        section_email_notifications: "經理與 HR 電郵",
        section_email_notifications_description: "選擇透過電郵傳送的活動提示、定期報告及回饋內容。",
        cancel: "取消",
        confirm: "確認",
        toast_valid_data_required: "需要有效資料。",
        toast_saving_changes: "儲存變更中...",
        toast_generated_attributes_prefix: "已為",
        toast_generated_attributes_middle: "生成屬性，對象為",
        toast_generate_attributes_failed: "生成屬性失敗，請再試一次。",
        toast_this_value: "此價值觀",
        toast_recognition_delete_prefix: "任何以",
        toast_recognition_delete_suffix: "發出的表揚將失去與此價值觀的關聯，此操作無法復原。",
        toast_delete_label: "刪除",
    },
    skills: {
        learning_journeys: {
            select_placeholder: "選擇",
            overview: "概覽",
            active_learning_journeys: "進行中的學習旅程",
            completed_journeys: "已完成旅程",
            members_upskilled: "已提升技能的成員",
            learning_time: "學習時間",
            activation_channel: "啟動渠道",
            activation_channel_description: "學習旅程由經理發起（專注績效）或由成員自發（個人成長）",
            manager: "經理",
            self: "自發",
            top_learners: "頂尖學員",
            top_learners_subtitle: "參與最多學習旅程的團隊成員",
            view_all: "查看全部",
            learning_journey_progress: "學習旅程進度",
            view_skill_category_analytics: "檢視技能類別分析",
            status: "狀態",
            skill_set: "技能組合",
            progress: "進度",
            initiated_by: "發起者",
            assigned_to: "指派給",
            date_time: "日期及時間",
            loading_more_items: "載入更多項目…",
            end_of_list: "列表結尾",
            empty_state: "沒有符合篩選條件的學習旅程。",
            top_learners_explanation: "於所選時間內參與最多學習旅程的團隊成員",
            search_member: "搜尋成員",
            no_learners_found: "沒有符合搜尋的學員。",
            skill_category_analytics: "技能類別分析",
            skill_category_analytics_subtitle: "按技能類別劃分的學習旅程分佈",
            time_period: "時間範圍：",
            search_category: "搜尋類別",
            categories: "類別",
            total_journeys: "總旅程數",
            active: "進行中",
            completed: "已完成",
            category: "類別",
            distribution: "分佈",
            total: "總計",
            no_categories_found: "沒有符合搜尋的類別。",
        },
        power_skills: {
            select_placeholder: "選擇",
            all_teams: "所有團隊",
            team: "團隊",
            progress_and_ratings: "Power Skills 進度與評分",
            progress_and_ratings_subtitle: "過去 6 個月練習各項技能的整體投入分數，附評分趨勢及排行榜",
            loading: "載入 Power Skills 資料中…",
            error_title: "無法載入 Power Skills 資料",
            retry: "重試",
            empty_title: "沒有 Power Skills 資料",
            empty_description: "所選條件沒有可顯示的資料。",
            company_avg: "公司平均",
            percentile_75th: "75th",
            median: "中位數",
            percentile_25th: "25th",
            leaderboard: "排行榜",
            sort_by: "排序依據",
            sort_all: "全部",
            ascending_rating: "評分由低至高",
            ascending_score: "分數由低至高",
            descending_rating: "評分由高至低",
            descending_score: "分數由高至低",
        },
        development: {
            select_placeholder: "Select a team",
            all_teams: "All Teams",
            search: "Search members",
            members_label: "members",
            vs_prior: "vs prior",
            member: "Member",
            rating_trend: "Rating trend",
            top_strength: "Top strength",
            development_area: "Development area",
            journeys: "Journeys",
            summary: "Summary",
            fresh: "Fresh",
            stale: "Stale",
            needs_data: "Needs data",
            none: "Not generated",
            completed_short: "done",
            active_short: "active",
            evidence: "Evidence",
            peer_count: "{n} peer",
            peers_count: "{n} peers",
            manager_review_count: "{n} manager review",
            manager_reviews_count: "{n} manager reviews",
            no_manager_reviews_short: "No manager reviews",
            no_feedback_yet: "No feedback yet",
            what_changed: "有何轉變",
            vs_previous_months: "對比之前 {n} 個月",
            peer_rating: "同事評分",
            manager_goals: "主管 · 目標",
            manager_culture: "主管 · 文化",
            mv_improved: "有進步",
            mv_new_strength: "新強項",
            mv_still_developing: "仍需發展",
            mv_watch: "需留意",
            mv_growth_to_strength: "之前為發展範疇 ×{was}，現為強項 ×{now}",
            mv_new_strength_detail: "本期強項 ×{now}，之前未曾提及",
            mv_still_detail: "兩期均為發展範疇（×{was} → ×{now}）",
            mv_watch_detail: "之前為強項，現為發展範疇 ×{now}",
            consistent_picture: "情況一致，沒有技能轉變。",
            recognized_for: "獲肯定範疇：",
            new_short: "新",
            volume_caption: "基於 {nowFb} 項同事回饋（{nowPeers} 位同事）及 {nowReviews} 次主管評核（對比之前 {prevFb} 項、{prevPeers} 位同事、{prevReviews} 次）",
            open_hint: "Click a member to open their development picture",
            back: "Back to roster",
            export: "Export",
            regenerate: "Regenerate",
            generated_on: "Generated",
            development_summary: "Development summary",
            provenance: "Generated from {feedback} feedback events, {journeys} journeys, {reviews} reviews",
            strengths_themes: "Strengths",
            development_areas: "Development areas",
            trajectory_statement: "Trajectory",
            suggested_focus: "Suggested focus",
            summary_unavailable: "Summary unavailable right now.",
            retry: "Retry",
            needs_data_hint: "Not enough feedback in this period to generate a summary. Evidence below shows what exists so far.",
            trajectory: "Trajectory",
            trajectory_hint: "Average peer-feedback rating received per month (1-4)",
            skills_title: "Strengths & development areas",
            skills_hint: "Peer feedback mentions in this period, with change vs the prior period",
            strengths: "Strengths",
            mentions: "mentions",
            evidence_journeys: "Learning journeys",
            evidence_recognition: "Recognition",
            evidence_behaviors: "Feedback behaviors",
            evidence_performance: "Performance",
            journeys_completed: "Completed",
            journeys_active: "In progress",
            learning_time: "Learning time",
            no_journeys: "No journeys in this period",
            received: "Received",
            given: "Given",
            no_recognition: "No recognition in this period",
            requested: "Requested",
            response_rate: "Response rate",
            no_feedback: "No feedback activity in this period",
            no_reviews: "No reviews",
            goal_rating: "Goals",
            culture_rating: "Culture",
            no_ratings: "No ratings yet",
            no_members: "No members match the current filters",
            member_not_found: "This member isn't in the current roster.",
            rating_truly: "Truly Outstanding",
            rating_exceeding: "Exceeding Expectations",
            rating_meeting: "Meeting Expectations",
            rating_needs: "Needs Improvement",
            holding: "holding",
            generate_report: "Generate report",
            generate_hint: "The AI development summary is generated on demand and cached for later visits.",
            generating: "Generating…",
            not_generated: "Not generated",
            deterministic_brief: "Development brief",
            strongest_signal: "Strongest signal",
            most_cited_growth: "Most-cited growth area",
            rating_label: "Rating",
            typically: "typically {label}",
            what_peers_said: "What peers said",
            mentions_count: "{n} mentions",
            mention_count: "{n} mention",
            new_label: "new",
            paraphrased_from: "Paraphrased from {n} comments",
            paraphrased_from_one: "Paraphrased from 1 comment",
            also_growth_note: "Also named a growth area by {n} peers",
            also_praised_note: "Also praised by {n} peers",
            privacy_quotes: "Quotes are AI-paraphrased and anonymous; original comments are never shown.",
            privacy_pre_ai: "Until the AI report is generated, this section lists cited behaviors and counts only.",
            self_reflection: "Self reflection · in their own words",
            own_answer_verbatim: "Their own answer, shown verbatim",
            reflection_source: "From {name}'s answers to Self Awareness reflection questions in this period ({n} total).",
            development_story: "Development story",
            feedback_loops: "Feedback loops — who, and when",
            peer_feedback_received: "Peer feedback received",
            manager_review_boost: "Manager review boost",
            manager_role: "manager",
            others_row: "{n} others",
            other_row: "1 other",
            growth_moments: "Growth moments",
            feedback_from: "Feedback from {names}",
            feedback_from_peers: "Feedback from {n} peers",
            baseline_title: "Baseline",
            now_title: "Now",
            manager_review_title: "Manager review boost",
            goals_label: "Goals",
            culture_label: "Culture",
            journeys_also: "Also this period: {done} journeys completed, {progress} in progress — {cats}.",
            journeys_also_none_progress: "Also this period: {done} journeys completed — {cats}.",
            manager_review_boosts: "Manager review boosts",
            no_manager_reviews: "No manager reviews in this period.",
            from_name: "from {name}",
            skill_balance: "Skill balance",
            activity_footnote: "Feedback activity this period: {received} received from {givers} givers · gave {given} — full activity lives in Proficiencies. Values recognition received: {tags} ({events} events).",
            strengths_cited: "Strengths cited: {names}.",
            growth_cited: "Growth: {names}.",
        },
        proficiencies: {
            select_placeholder: "選擇",
            all_teams: "所有團隊",
            all_time: "全部時間",
            past_year: "過去一年",
            past_6_months: "過去 6 個月",
            past_3_months: "過去 3 個月",
            current_month: "本月",
            last_month: "上月",
            overview: "概覽",
            rating_overview: "評分概覽",
            rating_overview_description: "同儕意見回饋中對公司目標的評分分佈。",
            truly_outstanding: "非常出色",
            exceeding_expectations: "超出期望",
            meeting_expectations: "達到期望",
            needs_improvement: "需要改善",
            highest_rated: "評分最高",
            highest_rated_description: "同儕意見回饋評分最高的人員（1 至 4 分制）",
            lowest_rated: "評分最低",
            lowest_rated_description: "同儕意見回饋評分最低的人員（1 至 4 分制）",
            see_all: "查看全部",
            skills_proficiency: "技能熟練度",
            skills_excel_at: "成員擅長的技能",
            skills_improve_at: "成員可改善的技能",
            skill_selected_description: "技能被選中的次數（與上一時段比較）",
            excels_at: "擅長於",
            could_further_improve: "可再改善",
            members_excel: "位成員擅長",
            members_could_improve: "位成員可再改善",
            peer_feedback_rating: "同儕意見回饋評分",
            rank: "排名",
            average_rating: "平均評分",
            interactions: "互動次數",
            peer_feedback: "同儕回饋",
            behaviors_title: "各成員的回饋行為",
            behaviors_description: "每位成員參與同儕回饋的程度，由請求、收到以至給予回饋，連同所獲得的平均評分",
            loading_behaviors: "正在載入同儕回饋活動...",
            requests_made: "提出請求",
            feedback_given: "給予回饋",
            participation: "參與度",
            requested: "請求",
            received: "收到",
            given: "給予",
            no_behaviors: "此期間沒有同儕回饋活動",
            strengths_title: "強項與發展領域",
            strengths_description: "同儕認可的強項技能與認為仍可成長的領域，協助規劃學習與發展的優先次序",
            strength_mentions: "強項提及",
            development_mentions: "發展提及",
            development_areas: "發展領域",
            strengths: "強項",
            mentions_label: "次提及",
            people_label: "人",
            showing_top_skills: "顯示提及次數最多的 10 項技能",
            members_label: "位成員",
            no_skill_mentions: "此期間沒有技能回饋",
            total_ratings: "總評分次數",
            ratings_label: "次評分",
            no_ratings: "此期間沒有同儕評分",
            asked: "被請求",
            receiving_feedback: "獲得回饋",
            giving_feedback: "給予回饋",
            response_rate: "回應率",
            response_rate_hint: "同儕向此成員提出的回饋請求中，此成員回應的比例",
            rating_short: "評分",
            requested_hint: "此成員向同儕提出的回饋請求",
            received_hint: "此成員從同儕收到的回饋",
            asked_hint: "同儕向此成員提出的回饋請求",
            given_hint: "此成員給予同儕的回饋",
            average_rating_hint: "同儕平均評分，由 1（需要改善）至 4（非常出色）",
            participation_hint: "此期間曾請求或給予回饋的成員比例",
            skill_details: "技能詳情",
            by_attribute: "按特質",
            attribute_hint: "提及中選取各項特質的比例",
        },
    },
    focus: {
        last_7_days: "過去 7 天",
        last_30_days: "過去 30 天",
        last_60_days: "過去 60 天",
        last_90_days: "過去 90 天",
    },
    programs: {
        Completion_reward: "Reward",
        Add_completion_reward: "Add reward",
        Currency_coins: "Coins",
        Currency_gems: "Gems",
        Currency_xp: "XP",
        Reward_needs_value: "1 reward needs a value",
        Reward_reason_placeholder: "Why are they getting this?",
    },
};
